<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; height: auto !important"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousFFView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>

          <!-- <md-button
              @click="previousFFView"
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
          ><md-icon icon="bell-fill" class="border rounded p-2">edit</md-icon></md-button>-->
          <b-navbar-brand center>Sales Execution Form</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <!-- <b-button
                size="sm"
                variant="danger"
                @click="showModalCon('SPLIT')"
                >Split Containers</b-button
              >-->
              <b-button
                v-if="
                  $sessionsStorage.get('nameUser') == 'Bhavneesh' &&
                  $sessionsStorage.get('designation') == 'Admin' &&
                  ffExoprtDetail.allModuleId != ''
                "
                style="margin-left: 5px"
                size="sm"
                variant="danger"
                @click="showModalLoc"
                >Change Location</b-button
              >
              <b-button
                v-if="
                  ffExoprtDetail.allModuleId != '' &&
                  ffExoprtDetail.shipmentType == '1' &&
                  ffExoprtDetail.newContainerFlow == '1'
                "
                style="margin-left: 5px"
                size="sm"
                variant="danger"
                @click="showModalCon"
                >Change Request Panel</b-button
              >
              <Filter-Agency-Modal />
              <FilterCBModal />
              <ClientCard />
              <ShipmentTrackCard />
              <!-- <b-button
                style="margin-left: 5px"
                size="sm"
                variant="danger"
                @click="showModalCon('REMOVE')"
                >Change Container Request</b-button
              >-->
            </b-nav-form>
          </b-navbar-nav>
          <div>

              <!-- v-if="ffExoprtDetail.clientIsActive == '2'" -->
            <b-button
            v-if="ffExoprtDetail.clientIsActive == '2'"
              size="sm"
              style="margin-left: 650px"
              variant="warning"
              @click="updateClient"
              >Convert To Client</b-button
            >
          </div>
        </b-navbar>
        <b-card class="formCard">
          <b-card-text>
            <!-- <b-alert
              v-if="execDoneData.length>0"
              show
              variant="danger"
            >Note : {{this.execDoneData[0].jobType}} has been Executed..!</b-alert>-->
            <div>
              <h5 class="mt-2 error" v-if="ffExoprtDetail.allModuleId != ''">
                JOB TYPE : {{ ShowJOB }} / Assignment No :
                {{ ffExoprtDetail.mainSalesSeries }}
              </h5>
            </div>
            <md-layout md-gutter class="gutr" v-if="ffExoprtDetail.allModuleId == ''">
              <md-layout md-flex="90" md-flex-small="100">
                <md-layout md-flex-small="100">
                  <!-- {{ SelectedNewJobType }} -->
                  <!-- {{newJobType}} -->
                  <!-- {{showSegmentArray}} -->

                  <md-layout
                    v-for="(segmentNameArray, index) in showSegmentArray"
                    :key="index"
                    :md-flex="segmentNameArray.flex"
                  >
                    <md-checkbox
                      v-model="ffExoprtDetail.jobType[index]"
                      class="md-primary"
                      :md-value="segmentNameArray.value"
                      :name="'jobType' + (index + 1)"
                      :id="'jobType' + (index + 1)"
                      :disabled="segmentNameArray.isDisabled"
                      @change="jobTypeSelect(segmentNameArray.value, index)"
                    ></md-checkbox>

                    <span
                      :style="
                        segmentNameArray.isDisabled == true
                          ? 'color:white;margin-top:17px'
                          : 'color:black;margin-top:17px'
                      "
                      >{{ segmentNameArray.show }}</span
                    >
                  </md-layout>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout md-gutter>
              <md-layout md-flex="25" class="pr-2">
                <label for="validBookingNo">
                  <!-- {{SelectedNewJobType}} -->
                  {{
                    // ffExoprtDetail.transportType == "Import" ? " BL No." : " Booking No."
                    (ffExoprtDetail.transportType == 'Export' || ffExoprtDetail.transportType == 'Import' || ffExoprtDetail.transportType == 'IMPORT') ? " BL No." : " Booking No."
                  }}
                </label>
                <!-- {{newJobType.indexOf('FF')}}{{ffExoprtDetail.transportType}}{{ffExoprtDetail.shipmentType}}{{ffExoprtDetail.containerInfo}} -->
                <!-- <model-list-select
                  v-if="
                    newJobType.indexOf('FF') >= 0 &&
                    ffExoprtDetail.transportType == 'Export' &&
                    ffExoprtDetail.shipmentType == 1 &&
                    ffExoprtDetail.containerInfo == 'fcl'
                  "
                  option-value="booking_no"
                  option-text="booking_no"
                  :list="ConsoleBookingList"
                  placeholder="Select Booking Number"
                  v-model="ffExoprtDetail.validBookingNo"
                  @searchchange="SelectConsoleBooking"
                ></model-list-select>-->
                <multi-select
                  v-if="
                    newJobType.indexOf('FF') >= 0 &&
                    (ffExoprtDetail.transportType == 'Export' || ffExoprtDetail.transportType == 'Import' || ffExoprtDetail.transportType == 'IMPORT') &&
                    ffExoprtDetail.shipmentType == 1 &&
                    ffExoprtDetail.containerInfo == 'fcl'
                  "
                  :options="ConsoleBookingList"
                  :selected-options="items"
                  v-model="ffExoprtDetail.validmultiBookingNo"
                  placeholder="Select Booking Number"
                  :multiple="true"
                  @select="SelectmultiConsoleBooking"
                ></multi-select>

                <!-- @searchchange="SelectConsoleBooking" -->
                <b-form-input
                  v-else
                  :formatter="capitalizeAll"
                  @input="
                    fetchExistExec();
                    checkFFCONBookingNo();
                  "
                  id="validBookingNo"
                  name="validBookingNo"
                  v-model="ffExoprtDetail.validBookingNo"
                ></b-form-input>

                <span
                  class="error"
                  v-if="
                    ConsoleBookingList.length <= 0 &&
                    newJobType.indexOf('FF') >= 0 &&
                    (ffExoprtDetail.transportType == 'Export' || ffExoprtDetail.transportType == 'Import' || ffExoprtDetail.transportType == 'IMPORT')
                    // ffExoprtDetail.transportType == 'Export' 
                    &&
                    ffExoprtDetail.shipmentType == 1 &&
                    ffExoprtDetail.containerInfo == 'fcl'
                  "
                  >{{ ConsoleBookingListMSG }}</span
                >

                <b> {{ timmerMsg }} </b>

                <b-button
                  @click="
                    checkAllCBBTN();
                    getConsoleBooking();
                  "
                  v-if="
                    newJobType.indexOf('FF') >= 0 &&
                    ffExoprtDetail.transportType == 'Export' &&
                    ffExoprtDetail.shipmentType == 1 &&
                    ffExoprtDetail.containerInfo == 'fcl' &&
                    $sessionsStorage.get('nameUser') == 'Bhavneesh' &&
                    $sessionsStorage.get('designation') == 'Admin'
                  "
                  style="font-size: 0.775rem"
                  variant="outline-primary"
                  v-model="checkAllCBVal"
                  >{{ checkAllCBVal ? "Selected" : "Un-Selected" }}</b-button
                >
              </md-layout>
              <!-- {{ffExoprtDetail}} -->
              <md-layout md-flex="10">
                <div class="row mt-5">
                  <div class="col-md-3">
                    <b-button
                      v-if="
                        (ffExoprtDetail.allModuleId != '' &&
                          $sessionsStorage.get('designation') == 'Admin' &&
                          ffExoprtDetail.engJobType.indexOf('FF') >= 0 &&
                          ffExoprtDetail.transportType == 'Export' &&
                          ffExoprtDetail.shipmentType == 1 &&
                          ffExoprtDetail.containerInfo == 'fcl' &&
                          checkCBNoButton == 1) ||
                        (ffExoprtDetail.isConsolidation == 1 && checkCBNoButton == 1)
                      "
                      style="font-size: 0.775rem"
                      variant="danger"
                      @click="updateBookingNo"
                      >Update Booking No</b-button
                    >
                  </div>
                </div>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <!-- <md-layout
                md-flex="5"
                v-if="
                  !showSegmentArray[0].isDisabled && ffExoprtDetail.jobType[0]
                "
              >-->
              <!-- <label for="clientId">Currency</label>

                <model-list-select
                  :list="currencyTypeList"
                  id="clientNamenew"
                  v-model="ffExoprtDetail.currencyType"
                  option-value="val"
                  option-text="type"
                  placeholder="Currency Type"
                  :isDisabled="false"
              ></model-list-select>-->
              <!-- <span class="error" v-if="!ffExoprtDetail.currencyType">{{
                  currencyTypeError
              }}</span>-->
              <!-- </md-layout> -->

              <!-- <md-layout md-flex="5"></md-layout>
              <md-layout
                md-flex="15"
                v-if="
                  !showSegmentArray[0].isDisabled && ffExoprtDetail.jobType[0]
                "
              >
                <label for="validBookingNo"> Agreed Buying Ocean Rate </label>

                <b-input
                  type="number"
                  id="freightNoOfContainers"
                  name="freightNoOfContainers"
                  v-model="ffExoprtDetail.agreedByingOceanRate"
              ></b-input>-->
              <!-- <span class="error" v-if="!ffExoprtDetail.agreedByingOceanRate">{{
                  agreedByingOceanRateError
              }}</span>-->
              <!-- </md-layout> -->
              <!-- <md-layout md-flex="5"></md-layout>
              <md-layout
                md-flex="15"
                v-if="
                  !showSegmentArray[0].isDisabled && ffExoprtDetail.jobType[0]
                "
              >
                <label for="validBookingNo"> Agreed Selling Ocean Rate </label>

                <b-input
                  type="number"
                  id="freightNoOfContainers"
                  name="freightNoOfContainers"
                  v-model="ffExoprtDetail.agreedSellingOceanRate"
              ></b-input>-->
              <!-- <span class="error" v-if="!ffExoprtDetail.agreedSellingOceanRate">{{
                  agreedSellingOceanRateError
              }}</span>-->
              <!-- </md-layout> -->
              <b-button
                v-if="showSameBookingError"
                style="margin-top: 35px"
                class="ml-2"
                size="sm"
                variant="outline-info"
                @click="showModalExist"
                >Show Executions</b-button
              >
            </md-layout>
            <div class="error mt-2">
              <h5 class="error">{{ showSameBookingError }}</h5>
              <div v-if="showSameBookingError">
                <b-form-checkbox
                  style="padding-top: none !important"
                  id="checkbox-1"
                  v-model="checkstatus"
                  name="checkbox-1"
                  value="1"
                  unchecked-value="0"
                ></b-form-checkbox>
                <span>
                  continue with mentioned
                  {{
                    // ffExoprtDetail.transportType == "Import" ? "BL No." : "Booking No."
                    (ffExoprtDetail.transportType == 'Export' || ffExoprtDetail.transportType == 'Import' || ffExoprtDetail.transportType == 'IMPORT') ? " BL No." : " Booking No."
                  }}
                </span>
              </div>
            </div>
            <md-layout md-gutter>
              <md-layout md-flex="25" class="pr-2">
                <label for="clientId">Client Type</label>

                <model-list-select
                  :list="clientTypeList"
                  id="clientNamenew"
                  v-model="ffExoprtDetail.clientType"
                  option-value="val"
                  option-text="type"
                  placeholder="Client Type"
                  :isDisabled="true"
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.clientType">
                  {{ clientTypeError }}
                </span>
              </md-layout>

              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="25" class="pl-2 pr-2">
                <label for="transportType">Shipping Type</label>
                <model-list-select
                  :list="shipmentTypeList"
                  v-model="ffExoprtDetail.shipmentType"
                  option-value="shipmentTypeVal"
                  option-text="shipmentTypeText"
                  placeholder="Select Shipment Type"
                  :isDisabled="true"
                ></model-list-select>

                <span class="error" v-if="!ffExoprtDetail.shipmentType">
                  {{ shipmentTypeError }}
                </span>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="20" class="pl-2 pr-2">
                <label for="transportType">Export / Import</label>
                <model-list-select
                  :list="transportTypeList"
                  v-model="ffExoprtDetail.transportType"
                  option-value="transportTypeVal"
                  option-text="transportTypeText"
                  placeholder="Select Type"
                  :isDisabled="true"
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.transportType">
                  {{ transportTypeError }}
                </span>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout
                md-flex="30"
                class="pl-2"
                v-if="ffExoprtDetail.clientType != '2'"
              >
                <label for="clientId">Client Name</label>

                <model-list-select
                  :list="clientList"
                  id="clientNamenew"
                  v-model="ffExoprtDetail.clientId"
                  option-value="clientId"
                  option-text="clientName"
                  placeholder="Select Existing Client Name"
                  :isDisabled="true"
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.clientId">
                  {{ clientIdError }}
                </span>
              </md-layout>
            </md-layout>

            <md-layout md-gutter v-if="ffExoprtDetail.clientType == '2'">
              <md-layout md-flex="50">
                <label for="clientId">Client Name</label>

                <b-form-input
                  :formatter="capitalizeAll"
                  id="newClientName"
                  name="newClientName"
                  v-model="ffExoprtDetail.newClientName"
                  :disabled="true"
                ></b-form-input>
                <span class="error" v-if="!ffExoprtDetail.newClientName">
                  {{ newClientNameError }}
                </span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="45">
                <label for="clientId">Client Email</label>

                <b-form-input
                  :formatter="capitalizeAll"
                  id="newClientEmail"
                  name="newClientEmail"
                  v-model="ffExoprtDetail.newClientEmail"
                  :disabled="true"
                ></b-form-input>
                <span class="error" v-if="!ffExoprtDetail.newClientEmail">
                  {{ newClientEmailError }}
                </span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter v-if="ffExoprtDetail.clientType == '2'">
              <md-layout md-flex="50">
                <label for="transportType">Contact No.</label>
                <b-form-input
                  :formatter="capitalizeAll"
                  id="newClientPhoneNumber"
                  name="newClientPhoneNumber"
                  type="number"
                  :disabled="true"
                  v-model="ffExoprtDetail.newClientPhoneNumber"
                ></b-form-input>
                <span class="error" v-if="!ffExoprtDetail.newClientPhoneNumber">{{
                  newClientPhoneNumberError
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="45">
                <label for="transportType">Client Address</label>
                <b-textarea
                  id="newClientAddress"
                  name="newClientAddress"
                  type="number"
                  :disabled="true"
                  v-model="ffExoprtDetail.newClientAddress"
                ></b-textarea>

                <span class="error" v-if="!ffExoprtDetail.newClientAddress">
                  {{ newClientAddressError }}
                </span>
              </md-layout>
            </md-layout>

            <div>
              <div>
                <md-layout md-gutter>
                  <md-layout
                    md-flex="25"
                    class="pr-2"
                    v-if="
                      ffExoprtDetail.pickupLocationId != '' &&
                      ffExoprtDetail.pickupLocationId != null &&
                      ffExoprtDetail.pickupLocationId != 0
                    "
                  >
                    <label for="AutoPickupLocation">Pickup Location</label>

                    <model-list-select
                      @input="getLocationList($event, 'All', 'getAlllocationHandover')"
                      @searchchange="
                        getLocationList($event, 'All', 'getAlllocationHandover')
                      "
                      :list="getAlllocationHandover"
                      v-model="ffExoprtDetail.pickupLocationId"
                      option-value="pickupId"
                      option-text="pickupLocation"
                      placeholder="Select Pickup Location"
                      :isDisabled="true"
                    ></model-list-select>

                    <span class="error" v-if="!ffExoprtDetail.pickupLocationId">{{
                      pickupLocationIdError
                    }}</span>
                  </md-layout>

                  <!-- <md-layout
                    md-flex="5"
                    v-if="
                      ffExoprtDetail.handoverLocationId != '' &&
                      ffExoprtDetail.handoverLocationId != null &&
                      ffExoprtDetail.handoverLocationId != 0
                    "
                  ></md-layout>-->
                  <md-layout
                    md-flex="25"
                    class="pl-2 pr-2"
                    v-if="
                      ffExoprtDetail.handoverLocationId != '' &&
                      ffExoprtDetail.handoverLocationId != null &&
                      ffExoprtDetail.handoverLocationId != 0
                    "
                  >
                    <label for="AutoHandoverLocation">Handover Location</label>

                    <model-list-select
                      @input="getLocationList($event, 'All', 'getAlllocationHandover')"
                      @searchchange="
                        getLocationList($event, 'All', 'getAlllocationHandover')
                      "
                      :list="getAlllocationHandover"
                      v-model="ffExoprtDetail.handoverLocationId"
                      option-value="pickupId"
                      option-text="pickupLocation"
                      placeholder="Select Handover Location"
                      :isDisabled="true"
                    ></model-list-select>

                    <span class="error" v-if="!ffExoprtDetail.handoverLocationId">{{
                      handoverLocationIdError
                    }}</span>
                  </md-layout>
                  <!-- <md-layout md-flex="5"></md-layout> -->
                  <md-layout
                    md-flex="50"
                    class="pl-2"
                    v-if="
                      ffExoprtDetail.handoverLocationId != '' &&
                      ffExoprtDetail.handoverLocationId != null &&
                      ffExoprtDetail.handoverLocationId != 0
                    "
                  >
                    <label for="AutoStuffingLocation">Factory Location</label>

                    <model-list-select
                      :isDisabled="disableFactory == true ? true : false"
                      :list="allLocationListFactory"
                      v-model="ffExoprtDetail.stuffingLocationId"
                      option-value="pickupId"
                      option-text="pickupLocation"
                      :placeholder="
                        allLocationList.length > 0
                          ? 'Select Factory Location'
                          : 'No Factory'
                      "
                    ></model-list-select>

                    <span class="error" v-if="!ffExoprtDetail.stuffingLocationId">{{
                      stuffingLocationIdError
                    }}</span>
                  </md-layout>
                </md-layout>
                <md-layout md-gutter>
                  <md-layout
                    v-if="
                      ffExoprtDetail.handoverLocationId != '' &&
                      ffExoprtDetail.handoverLocationId != null &&
                      ffExoprtDetail.handoverLocationId != 0
                    "
                  >
                    <b-button
                      v-if="ffExoprtDetail.allModuleId == '' && disableFactory == false"
                      size="sm"
                      variant="outline-info"
                      @click="showModal"
                      >Add Factory</b-button
                    >
                  </md-layout>
                </md-layout>

                <md-layout md-gutter>
                  <md-layout
                    md-flex="50"
                    class="pr-2"
                    v-if="
                      ffExoprtDetail.tptType != '' &&
                      ffExoprtDetail.tptType != null &&
                      ffExoprtDetail.tptType != 0
                    "
                  >
                    <label for="ccType">TPT Type</label>
                    <model-list-select
                      :list="cctypeList"
                      v-model="ffExoprtDetail.tptType"
                      option-value="ccTypeVal"
                      option-text="ccTypeTxt"
                      placeholder="Select TPT Type"
                      :isDisabled="true"
                    ></model-list-select>
                  </md-layout>
                  <md-layout md-flex="5" v-if="ffExoprtDetail.tptType == '2'"></md-layout>
                  <md-layout md-flex="30" v-if="ffExoprtDetail.tptType == '2'">
                    <md-layout md-flex="100">
                      <label>Transporter Name</label>
                      <b-form-input
                        :formatter="capitalizeAll"
                        id="transporterName"
                        name="transporterName"
                        v-model="ffExoprtDetail.transporterName"
                        :disabled="true"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5" v-if="ffExoprtDetail.tptType == '2'"></md-layout>
                  <md-layout
                    md-flex="25"
                    v-if="
                      ffExoprtDetail.onAccountOf != '' &&
                      ffExoprtDetail.onAccountOf != null &&
                      ffExoprtDetail.onAccountOf != 0
                    "
                  >
                    <md-layout md-flex="100">
                      <label>ON ACCOUNT OF</label>
                      <b-form-input
                        :formatter="capitalizeAll"
                        id="onAccountOf"
                        name="onAccountOf"
                        v-model="ffExoprtDetail.onAccountOf"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                </md-layout>
              </div>

              <md-layout md-gutter v-for="(item, index) in multiContainer" :key="index">
                <md-layout md-flex="50" class="pr-2">
                  <label>{{ index + 1 }} - Container Type *</label>

                  <b-form-input
                    :formatter="capitalizeAll"
                    v-model="multiContainer[index].containerType"
                    disabled
                  ></b-form-input>
                </md-layout>
                <!-- <md-layout md-flex="5"></md-layout> -->

                <md-layout md-flex="50" class="pl-2">
                  <label>No. of Container *</label>

                  <b-input
                    type="text"
                    id="freightNoOfContainers"
                    name="freightNoOfContainers"
                    v-model="multiContainer[index].freghtContainersNo"
                  ></b-input>
                </md-layout>

                <md-layout md-flex="5">
                  <div style="padding: 5px">
                    <b-button
                      v-if="multiContainer.length > 1 && ffExoprtDetail.allModuleId == ''"
                      style="margin-top: 40px"
                      @click="removeContainerType(index)"
                      size="sm"
                      variant="light"
                      class="mb-2"
                    >
                      <i class="fa fa-minus-circle"></i>
                    </b-button>
                  </div>
                  <!-- <b-button
                    
                  
                    size="sm"
                  >Remove</b-button>-->
                </md-layout>
              </md-layout>

              <div>
                <md-layout md-gutter>
                  <md-layout md-flex="50" class="pr-2">
                    <label for="containerInfo">FF Activity Type</label>
                    <model-list-select
                      :list="containerInfoList"
                      v-model="ffExoprtDetail.containerInfo"
                      option-value="containerInfoVal"
                      option-text="containerInfoText"
                      placeholder="Select Activity Type"
                      :isDisabled="true"
                    ></model-list-select>
                    <span class="error" v-if="!ffExoprtDetail.containerInfo">
                      {{ containerInfoError }}
                    </span>
                  </md-layout>
                  <!-- <md-layout md-flex="5"></md-layout> -->
                  <md-layout md-flex="50" class="pl-2">
                    <label>Estimated Date</label>
                    <date-picker
                      width="100%"
                      lang="en"
                      name="weighingDate"
                      id="weighingDate"
                      type="datetime"
                      format="YYYY-MM-DD hh:mm a"
                      v-model="ffExoprtDetail.estimatedDate"
                      :isDisabled="true"
                    ></date-picker>
                  </md-layout>
                </md-layout>
                <md-layout md-gutter>
                  <md-layout md-flex="50" class="pr-2">
                    <label for="clientId">Importer Name (Freight)</label>

                    <model-list-select
                      :list="getImporterExpo"
                      id="clientNamenew"
                      v-model="ffExoprtDetail.importerClientId"
                      option-value="clientId"
                      option-text="clientName"
                      placeholder="Select Importer Name"
                      :isDisabled="ffExoprtDetail.clientType != '3' ? true : false"
                    ></model-list-select>
                    <span class="error" v-if="!ffExoprtDetail.importerClientId">{{
                      importerClientIdError
                    }}</span>
                  </md-layout>
                  <!-- <md-layout md-flex="5"></md-layout> -->
                  <md-layout md-flex="50" class="pl-2">
                    <label for="clientId">Exporter Name (Freight)</label>

                    <model-list-select
                      :list="getImporterExpo"
                      id="clientNamenew"
                      v-model="ffExoprtDetail.exporterClientId"
                      option-value="clientId"
                      option-text="clientName"
                      placeholder="Select Exporter Name"
                      :isDisabled="ffExoprtDetail.clientType != '3' ? true : false"
                    ></model-list-select>
                    <span class="error" v-if="!ffExoprtDetail.exporterClientId">{{
                      exporterClientIdError
                    }}</span>
                  </md-layout>
                </md-layout>

                <md-layout md-gutter>
                  <md-layout md-flex="50" class="pl-2">
                    <label v-if="openImpoInput == true" for="clientId"
                      >Importer Name</label
                    >

                    <b-form-input
                      :formatter="capitalizeAll"
                      disabled
                      v-if="openImpoInput == true"
                      id="otherImpoName"
                      name="otherImpoName"
                      v-model="ffExoprtDetail.otherImpoName"
                    ></b-form-input>
                  </md-layout>
                  <!-- <md-layout md-flex="5"></md-layout> -->
                  <md-layout md-flex="50" class="pl-2" v-if="openExpoInput == true">
                    <label for="clientId">Exporter Name</label>

                    <b-form-input
                      :formatter="capitalizeAll"
                      disabled
                      id="otherExpoName"
                      name="otherExpoName"
                      v-model="ffExoprtDetail.otherExpoName"
                    ></b-form-input>
                  </md-layout>
                </md-layout>

                <div v-if="ffExoprtDetail.shipmentType == '1'">
                  <md-layout md-gutter>
                    <md-layout md-flex="50" class="pr-2">
                      <label for="stuffingType">Stuffing Type</label>
                      <model-list-select
                        :list="stuffingTypeList"
                        v-model="ffExoprtDetail.stuffingType"
                        option-value="stuffingTypeVal"
                        option-text="stuffingTypeText"
                        placeholder="Select Stuffing Type"
                        :isDisabled="true"
                      ></model-list-select>
                      <span class="error" v-if="!ffExoprtDetail.stuffingType">
                        {{ stuffingTypeError }}
                      </span>
                    </md-layout>
                    <!-- <md-layout md-flex="5"></md-layout> -->

                    <md-layout md-flex="50" class="pl-2">
                      <label for="shippingId">Shipping Line Name</label>

                      <!-- {{ newJobType.indexOf("TPT") }}
                      {{ffExoprtDetail}}-->
                      <!-- {{ ShowJOB }} -->
                        
                      <!-- :isDisabled="true" -->
                      <model-list-select
                        v-if="
                          ffExoprtDetail.shipmentType == '1' &&
                          ffExoprtDetail.multipleContainerTypeId == '15' &&
                          ffExoprtDetail.transportType == 'Export' &&
                          newJobType
                            ? newJobType.indexOf('TPT')
                            : ffExoprtDetail.engJobType.indexOf('TPT') >= 0 &&
                              ffExoprtDetail.containerInfo == 'lcl'
                        "
                        :list="getColoaderNameList"
                        v-model="ffExoprtDetail.shippingId"
                        option-value="agntColoaderId"
                        option-text="coLoaderName"
                        placeholder="Select Shipping Line"
                      ></model-list-select>
                      <model-list-select
                        v-else
                        :list="shippingList"
                        v-model="ffExoprtDetail.shippingId"
                        option-value="shippingId"
                        option-text="shippingLine"
                        placeholder="Select Shipping Line"
                      ></model-list-select>
                      
                      <!-- :isDisabled="true" -->
                      <span class="error" v-if="!ffExoprtDetail.shippingId">
                        {{ shippingIdError }}
                      </span>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter>
                    <md-layout md-flex="50" class="pr-2">
                      <label for="PORlocationId">Place of Receipt (Freight)</label>
                      <model-list-select
                        @input="getLocationList($event, 'Icd,Sea_Port', 'IcdPOrtList')"
                        @searchchange="
                          getLocationList($event, 'Icd,Sea_Port', 'IcdPOrtList')
                        "
                        :list="IcdPOrtList"
                        v-model="ffExoprtDetail.PORlocationId"
                        option-value="pickupId"
                        option-text="pickupLocation"
                        placeholder="Select Place of Receipt"
                      ></model-list-select>
                      <span class="error" v-if="!ffExoprtDetail.PORlocationId">{{
                        PORlocationIdError
                      }}</span>
                    </md-layout>

                    <!-- <md-layout md-flex="5"></md-layout> -->
                    <md-layout md-flex="50" class="pl-2">
                      <label for="LPlocationId">Load Port Name (Freight)</label>
                      <!-- :isDisabled="ffExoprtDetail.portType!='Icd'?true:false" -->
                      <model-list-select
                        @input="
                          getLocationList(
                            $event,
                            ffExoprtDetail.shipmentType == '1' &&
                              ffExoprtDetail.transportType == 'Export'
                              ? 'Sea_Port_India'
                              : 'Sea_Port_NonIndia',
                            'PortLoadList'
                          )
                        "
                        @searchchange="
                          getLocationList(
                            $event,
                            ffExoprtDetail.shipmentType == '1' &&
                              ffExoprtDetail.transportType == 'Export'
                              ? 'Sea_Port_India'
                              : 'Sea_Port_NonIndia',
                            'PortLoadList'
                          )
                        "
                        :list="PortLoadList"
                        v-model="ffExoprtDetail.LPlocationId"
                        option-value="pickupId"
                        option-text="pickupLocation"
                        placeholder="Select Load Port Name"
                        :isDisabled="ShowJOB.split(',').includes('FF') ? true : false"
                        :isError="ffExoprtDetail.portType != 'Icd' ? true : false"
                      ></model-list-select>
                      <span class="error" v-if="!ffExoprtDetail.LPlocationId">
                        {{ LPlocationIdError }}
                      </span>
                    </md-layout>
                  </md-layout>

                  <md-layout md-gutter>
                    <md-layout md-flex="50" class="pr-2">
                      <label for="PODLocationId">Port of Discharge (Freight)</label>
                      <model-list-select
                        @input="
                          getLocationList(
                            $event,
                            ffExoprtDetail.shipmentType == '1' &&
                              ffExoprtDetail.transportType == 'Export'
                              ? 'Sea_Port_NonIndia'
                              : 'Sea_Port_India',
                            'getPortDischargeList'
                          )
                        "
                        @searchchange="
                          getLocationList(
                            $event,
                            ffExoprtDetail.shipmentType == '1' &&
                              ffExoprtDetail.transportType == 'Export'
                              ? 'Sea_Port_NonIndia'
                              : 'Icd,Sea_Port_India',
                            'getPortDischargeList'
                          )
                        "
                        :list="PortDischargeList"
                        v-model="ffExoprtDetail.PODLocationId"
                        option-value="pickupId"
                        option-text="pickupLocation"
                        placeholder="Select POD"
                        :isDisabled="
                          newJobType.indexOf('FF') >= 0 || ffExoprtDetail.allModuleId
                            ? true
                            : false
                        "
                      ></model-list-select>
                      <span class="error" v-if="!ffExoprtDetail.PODLocationId">{{
                        PODLocationIdError
                      }}</span>
                    </md-layout>
                    <!-- <md-layout md-flex="5"></md-layout> -->
                    <md-layout md-flex="50" class="pl-2">
                      <label for="finalPlaceLocationId"
                        >Final Place of Delivery (Freight)</label
                      >
                      <model-list-select
                        @input="
                          getLocationList(
                            $event,
                            ffExoprtDetail.shipmentType == '1' &&
                              ffExoprtDetail.transportType == 'Export'
                              ? 'Sea_Port_NonIndia'
                              : 'Icd,Sea_Port_India',
                            'finalAllPlaceData'
                          )
                        "
                        @searchchange="
                          getLocationList(
                            $event,
                            ffExoprtDetail.shipmentType == '1' &&
                              ffExoprtDetail.transportType == 'Export'
                              ? 'Sea_Port_NonIndia'
                              : 'Icd,Sea_Port_India',
                            'finalAllPlaceData'
                          )
                        "
                        :list="finalAllPlaceData"
                        v-model="ffExoprtDetail.finalPlaceLocationId"
                        option-value="pickupId"
                        option-text="pickupLocation"
                        placeholder="Select FPOD"
                        :isDisabled="
                          newJobType.indexOf('FF') >= 0 || ffExoprtDetail.allModuleId
                            ? true
                            : false
                        "
                      ></model-list-select>
                      <span class="error" v-if="!ffExoprtDetail.finalPlaceLocationId">{{
                        finalPlaceLocationIdError
                      }}</span>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter>
                    <md-layout md-flex="50" class="pr-2">
                      <label for="deliveryMode">Destination Delivery Mode</label>
                      <model-list-select
                        :list="deliveryModeList"
                        v-model="ffExoprtDetail.deliveryMode"
                        option-value="deliveryModeVal"
                        option-text="deliveryModeText"
                        placeholder="Select Delivery Mode"
                      ></model-list-select>
                    </md-layout>
                    <!-- <md-layout md-flex="5"></md-layout> -->

                    <md-layout md-flex="50" class="pl-2">
                      <label for="deliveryTerms">Delivery Terms(INCOTERMS)</label>
                      <model-list-select
                        :list="deliveryTermsList"
                        v-model="ffExoprtDetail.deliveryTerms"
                        option-value="deliveryTermsVal"
                        option-text="deliveryTermsText"
                        placeholder="Select Delivery Terms"
                      ></model-list-select>
                    </md-layout>
                  </md-layout>
                </div>

                <div>
                  <md-layout md-gutter v-if="ffExoprtDetail.shipmentType == '2'">
                    <md-layout md-flex="50" class="pr-2">
                      <label for="PORlocationId">Airport of Departure</label>
                      <model-list-select
                        @input="getLocationList($event, 'Air_Port', 'IcdPOrtList')"
                        @searchchange="
                          getLocationList($event, 'Air_Port', 'AirIcdPOrtList')
                        "
                        :list="AirIcdPOrtList"
                        v-model="ffExoprtDetail.airportDeparture"
                        option-value="pickupId"
                        option-text="pickupLocation"
                        placeholder="Select Airport Departure"
                        :isDisabled="true"
                      ></model-list-select>
                      <span class="error" v-if="!ffExoprtDetail.airportDeparture">{{
                        airportDepartureError
                      }}</span>
                    </md-layout>

                    <!-- <md-layout md-flex="5"></md-layout> -->
                    <md-layout md-flex="50" class="pl-2">
                      <label for="LPlocationId">Airport of Destination</label>
                      <model-list-select
                        @input="getLocationList($event, 'Air_Port', 'PortLoadList')"
                        @searchchange="
                          getLocationList($event, 'Air_Port', 'AirPortLoadList')
                        "
                        :list="AirPortLoadList"
                        v-model="ffExoprtDetail.airportDestination"
                        option-value="pickupId"
                        option-text="pickupLocation"
                        placeholder="Select Destination"
                        :isDisabled="true"
                      ></model-list-select>
                      <span class="error" v-if="!ffExoprtDetail.airportDestination">{{
                        airportDestinationError
                      }}</span>
                    </md-layout>
                  </md-layout>
                  <div>
                    <md-layout md-gutter>
                      <md-layout
                        md-flex="50"
                        v-if="ffExoprtDetail.shipmentType == '2'"
                        md-flex-small="100"
                        class="gutr"
                      >
                        <label for="containerTypeId">Airline</label>
                        <model-list-select
                          isDisabled
                          :list="airLineList"
                          v-model="ffExoprtDetail.airlineId"
                          option-value="airlineId"
                          option-text="airlineName"
                          placeholder="Select Airline"
                        ></model-list-select>
                        <!-- <span
                      class="error"
                      v-if="!ffExoprtDetail.transContainerTypeId"
                        >{{transContainerTypeIdError}}</span>-->
                      </md-layout>
                      <md-layout
                        md-flex="5"
                        v-if="ffExoprtDetail.shipmentType == '2'"
                      ></md-layout>
                      <md-layout
                        md-flex="25"
                        v-if="
                          ffExoprtDetail.shipmentType == '1' &&
                          ffExoprtDetail.containerInfo == 'lcl'
                        "
                      >
                        <label for="agentName">CoLoader Name</label>
                        <model-list-select
                          isDisabled
                          :list="getColoaderNameList"
                          v-model="ffExoprtDetail.coLoaderId"
                          option-value="agntColoaderId"
                          option-text="coLoaderName"
                          placeholder="Select Coloader Name"
                        ></model-list-select>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>

                      <md-layout
                        md-flex="20"
                        v-if="
                          ffExoprtDetail.shipmentType == '2' ||
                          ffExoprtDetail.containerInfo == 'lcl'
                        "
                        md-flex-small="100"
                      >
                        <md-layout md-flex="100">
                          <label for="noOfPkg">No. of Packages</label>

                          <b-form-input
                            :formatter="capitalizeAll"
                            id="noOfPkg"
                            name="noOfPkg"
                            type="number"
                            v-model="ffExoprtDetail.noOfPkg"
                          ></b-form-input>
                        </md-layout>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="20" v-if="ffExoprtDetail.shipmentType == '2'">
                        <label for="PORlocationId">Cargo Received At</label>
                        <model-list-select
                          :list="cargoReceivedList"
                          v-model="ffExoprtDetail.cargoReceived"
                          option-value="val"
                          :isDisabled="true"
                          option-text="type"
                          placeholder="Select Cargo Received"
                        ></model-list-select>
                        <span class="error" v-if="!ffExoprtDetail.cargoReceived">{{
                          cargoReceivedError
                        }}</span>
                      </md-layout>
                      <!-- <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="20" md-flex-small="100">
                        <md-layout md-flex="100">
                          <label for="grossVolWgt">Gross Volume Wgt.</label>

                          <b-form-input :formatter="capitalizeAll"
                            id="grossVolWgt"
                            name="grossVolWgt"
                            type="number"
                            v-model="ffExoprtDetail.grossVolWgtAir"
                          ></b-form-input>
                        </md-layout>
                      </md-layout>-->
                    </md-layout>
                  </div>

                  <md-layout md-gutter v-if="ffExoprtDetail.shipmentType == '2'">
                    <md-layout md-flex="50">
                      <label for="LPlocationId">Destination Delievery Mode</label>
                      <model-list-select
                        :list="destinationDelieveryList"
                        v-model="ffExoprtDetail.destinationModeAir"
                        option-value="val"
                        option-text="type"
                        :isDisabled="true"
                        placeholder="Select Destination"
                      ></model-list-select>
                      <span class="error" v-if="!ffExoprtDetail.destinationModeAir">{{
                        destinationModeAirError
                      }}</span>
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>

                    <md-layout
                      md-flex="45"
                      v-if="ffExoprtDetail.destinationModeAir == '2'"
                    >
                      <label for="LPlocationId">FPOD</label>
                      <model-list-select
                        @input="
                          getLocationList(
                            $event,
                            ffExoprtDetail.shipmentType == '1' &&
                              ffExoprtDetail.transportType == 'Export'
                              ? 'Sea_Port_NonIndia'
                              : 'Icd,Sea_Port_India',
                            'finalAllPlaceData'
                          )
                        "
                        @searchchange="
                          getLocationList(
                            $event,
                            ffExoprtDetail.shipmentType == '1' &&
                              ffExoprtDetail.transportType == 'Export'
                              ? 'Sea_Port_NonIndia'
                              : 'Icd,Sea_Port_India',
                            'finalAllPlaceData'
                          )
                        "
                        :list="finalAllPlaceData"
                        v-model="ffExoprtDetail.doorDestinationfpod"
                        option-value="pickupId"
                        option-text="pickupLocation"
                        placeholder="Select Destination"
                        :isDisabled="true"
                      ></model-list-select>
                    </md-layout>
                  </md-layout>
                </div>

                <md-layout md-gutter v-if="ffExoprtDetail.shipmentType == '1'">
                  <md-layout md-flex="50" class="pr-2">
                    <label for="ccType">CC Type</label>
                    <model-list-select
                      :list="cctypeList"
                      v-model="ffExoprtDetail.ccType"
                      option-value="ccTypeVal"
                      option-text="ccTypeTxt"
                      placeholder="Select CC Type"
                    ></model-list-select>
                  </md-layout>
                  <!-- <md-layout md-flex="5"></md-layout> -->
                  <md-layout
                    md-flex="50"
                    class="pl-2"
                    v-if="ffExoprtDetail.ccType == '2'"
                  >
                    <md-layout md-flex="100">
                      <label>CHA Name</label>
                      <b-form-input
                        :formatter="capitalizeAll"
                        id="ccCha"
                        name="ccCha"
                        disabled
                        v-model="ffExoprtDetail.ccCha"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                </md-layout>
                <md-layout md-gutter>
                  <md-layout md-flex="50" class="pr-2">
                    <md-layout md-flex="100">
                      <label for="otherComodity">Commodity Details</label>

                      <b-form-textarea
                        :formatter="capitalizeAll"
                        id="otherComodity"
                        name="otherComodity"
                        v-model="ffExoprtDetail.otherComodity"
                      ></b-form-textarea>
                    </md-layout>
                  </md-layout>
                  <!-- <md-layout md-flex="5"></md-layout> -->

                  <md-layout md-flex="50" class="pl-2 pr-2">
                    <label for="commodityType">Commodity Type</label>
                    <model-list-select
                      :list="commodityTypeName"
                      v-model="ffExoprtDetail.commodityType"
                      option-value="commodityTypeVal"
                      option-text="commodityTypeText"
                      placeholder="Select Commodity Type"
                      :isDisabled="true"
                    ></model-list-select>
                    <span class="error" v-if="!ffExoprtDetail.commodityType">{{
                      commodityTypeError
                    }}</span>
                  </md-layout>
                  <md-layout md-flex="50" class="pl-2">
                    <md-layout md-flex="100">
                      <label>Remarks</label>
                      <b-form-textarea
                        :formatter="capitalizeAll"
                        id="remark"
                        name="remark"
                        v-model="ffExoprtDetail.remark"
                      ></b-form-textarea>
                    </md-layout>
                  </md-layout>
                </md-layout>

                <md-layout md-gutter v-if="ffExoprtDetail.commodityType == 'Hazardous'">
                  <md-layout md-flex="50" class="pl-2 pr-2">
                    <md-layout md-flex="100">
                      <label>IMDG Class</label>
                      <b-form-input
                        :formatter="capitalizeAll"
                        id="IMDGClass"
                        name="IMDGClass"
                        v-model="ffExoprtDetail.IMDGClass"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="25" class="pl-2 pr-2">
                    <md-layout md-flex="100">
                      <label>UN Number</label>
                      <b-form-input
                        :formatter="capitalizeAll"
                        id="UNNumber"
                        name="UNNumber"
                        v-model="ffExoprtDetail.UNNumber"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="20" class="pl-2 pr-2">
                    <md-layout md-flex="100">
                      <label>Packing Code</label>
                      <b-form-input
                        :formatter="capitalizeAll"
                        id="packingCode"
                        name="packingCode"
                        v-model="ffExoprtDetail.packingCode"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter v-if="ffExoprtDetail.commodityType == 'Reefer'">
                    <md-layout md-flex="25" class="pl-2 pr-2">
                      <md-layout md-flex="100">
                        <label>Temperature Req(Degree Celsius)</label>
                        <b-form-input
                          :formatter="capitalizeAll"
                          id="temperatureRequired"
                          name="temperatureRequired"
                          v-model="ffExoprtDetail.temperatureRequired"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter v-if="ffExoprtDetail.commodityType == 'Others'">
                    <md-layout md-flex="100" class="pl-2 pr-2">
                      <md-layout md-flex="100">
                        <label>Specific Detail if any..!</label>
                        <b-form-input
                          :formatter="capitalizeAll"
                          id="otherComodity"
                          name="otherComodity"
                          v-model="ffExoprtDetail.otherComodity"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                  </md-layout>
                </md-layout>
              </div>

              <div>
                <md-layout md-gutter v-if="ffExoprtDetail.commodityType == 'Others'">
                  <md-layout md-flex="100">
                    <md-layout md-flex="100">
                      <label>Specific Detail if any..!</label>
                      <b-form-input
                        :formatter="capitalizeAll"
                        id="otherComodity"
                        name="otherComodity"
                        v-model="ffExoprtDetail.otherComodity"
                        :disabled="true"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                </md-layout>
              </div>

              <md-layout md-gutter v-if="allModuleIdNew == '' || allModuleIdNew == null">
                <!-- :disabled="DisableSubmit" -->
                <!-- {{this.ffExoprtDetail.validmultiBookingNo.length}} -->
                <b-button
                  :disabled="
                    (checkstatus == '0' && showSameBookingError) ||
                    !this.ffExoprtDetail.validBookingNo
                      ? true
                      : false
                  "
                  class="mt-4 smbutnWidth"
                  v-if="ffExoprtDetail.allModuleId == ''"
                  variant="primary"
                  id="addButtonLoader"
                  @click="addFFExport"
                  >Save & Send To Execution</b-button
                >
                <md-spinner
                  md-indeterminate
                  id="loader"
                  style="display: none"
                ></md-spinner>
              </md-layout>
            </div>
          </b-card-text>

          <b-col lg="12">
            <span class="error pull-right" v-if="ffExoprtDetail.SalesExecutionCreated">
              <b> {{ ffExoprtDetail.SalesExecutionCreated }}</b>
            </span>
          </b-col>

          <!-- <b-col lg="12">
            <span class="error pull-right" v-if="ffExoprtDetail.SalesExecutionUpdated">
              <b> {{ ffExoprtDetail.SalesExecutionUpdated }}</b>
            </span>  
          </b-col> -->

          <!-- <b-col lg="12"> {{ ffExoprtDetail }} </b-col> -->
        </b-card>
      </b-card-text>
    </b-card>
    <!-- <md-dialog class="HereDialog" md-open-from="#custom" md-close-to="#custom" ref="dialogLocation">
      <md-dialog-content>
        <clientForm
          :clientIdSales="ffExoprtDetail.clientType=='3' && ffExoprtDetail.shipmentType=='1' && ffExoprtDetail.transportType=='Export' ?ffExoprtDetail.exporterClientId:ffExoprtDetail.clientId"
        />
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="closeModalLocation">Close</md-button>
      </md-dialog-actions>
    </md-dialog>-->
    <div>
      <b-modal
        no-close-on-esc
        no-close-on-backdrop
        ref="my-modal-exist"
        size="lg"
        ok-only
        title
      >
        <h5 class="error mt-2">
          Existing Execution with
          {{ ffExoprtDetail.transportType == "Import" ? " BL No. " : " Booking No. " }}
          {{ ffExoprtDetail.validBookingNo }}
        </h5>
        <div class="d-block text-center mt-2">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Execution No.</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in allExistingData" :key="index">
                <th scope="row">{{ index + 1 }}</th>
                <td>{{ item.mainSalesSeries }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal no-close-on-esc no-close-on-backdrop ref="my-modal" hide-footer title>
        <div class="d-block text-center">
          <span class="error">Fileld Marked with * are mandatory..!</span>
          <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="100">
              <md-layout md-flex="100">
                <label> Factory Title-Location ( e.g : Pridel Pvt Ltd-Delhi ) * </label>
                <b-form-input
                  :formatter="capitalizeAll"
                  name="factoryTitle"
                  id="factoryTitle"
                  v-model="factoryModal.factoryTitle"
                ></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>

          <!-- <md-layout md-gutter class="gutr">
            <label for="AutoPickupLocation">Search Location</label>
            <md-layout md-flex="100">
            
              <model-list-select
              @input="fetchLoc()"
                :list="getLocSearchResults"
                v-model="factoryModal.locSearch"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder="Search  Location"
              ></model-list-select>
            </md-layout>
          </md-layout>-->
          <md-layout md-gutter class="gutr">
            <md-layout md-flex="100">
              <md-layout md-flex="100">
                <label>Address (Area/Locality,District,City,State,Country)</label>
                <b-form-textarea
                  :formatter="capitalizeAll"
                  name="factoryAddress1"
                  id="factoryAddress1"
                  v-model="factoryModal.factoryAddress1"
                ></b-form-textarea>
              </md-layout>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="gutr">
            <md-layout md-flex="10">
              <b-button size="sm" variant="primary" @click="fetchLatLog"
                >Get Lat/Long</b-button
              >
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="gutr">
            <md-layout md-flex="45">
              <md-layout md-flex="100">
                <label>Latitude *</label>
                <b-form-input
                  :formatter="capitalizeAll"
                  type="number"
                  min="0"
                  id="latitude"
                  name="latitude"
                  v-model="factoryModal.latitude"
                ></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="45">
              <md-layout md-flex="100">
                <label>Longitude *</label>
                <b-form-input
                  :formatter="capitalizeAll"
                  type="number"
                  min="0"
                  id="latitude"
                  name="latitude"
                  v-model="factoryModal.longitude"
                ></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="gutr">
            <md-layout md-flex="100">
              <md-layout md-flex="100">
                <label>GSTIN No</label>
                <b-form-input
                  :formatter="capitalizeAll"
                  name="GSTIN1"
                  id="GSTIN1"
                  v-model="factoryModal.GSTIN1"
                ></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>
          <div class="error mt-3">
            <span class="error mt-3">{{ showFactLocError }}</span>
          </div>
        </div>
        <b-button class="mt-2" variant="success" block @click="addClient('')"
          >Add Factory</b-button
        >
        <b-button class="mt-3" variant="outline-danger" block @click="hideModal"
          >Close</b-button
        >
      </b-modal>
    </div>
    <div>
      <b-modal
        size="xl"
        no-close-on-esc
        no-close-on-backdrop
        ref="my-modal-con"
        hide-footer
        title="Manage Assignment Containers"
      >
        <!-- <h5 class="mt-2"></h5> -->
        <b-form-group>
          <b-form-radio-group
            @change="changeOnRadio"
            id="radio-group-2"
            v-model="actionType"
            name="radio-sub-component"
          >
            <!-- {{ffExoprtDetail.engJobType}} -->
            <b
              v-if="
                (ffExoprtDetail.engJobType.indexOf('FF') >= 0 ||
                  ffExoprtDetail.engJobType.indexOf('CC') >= 0 ||
                  ffExoprtDetail.engJobType.indexOf('TPT') >= 0) &&
                (ffExoprtDetail.transportType == 'Export' ||
                  ffExoprtDetail.transportType == 'Import')
              "
            >
              <b-form-radio
                size="lg"
                v-if="
                  ffExoprtDetail.transportType == 'Export' ||
                  ffExoprtDetail.transportType == 'Import'
                "
                value="SPLIT"
                >Move Container & Create New Assignment (Split)</b-form-radio
              >
            </b>
            <b
              v-if="
                (ffExoprtDetail.engJobType.indexOf('FF') >= 0 ||
                  ffExoprtDetail.engJobType.indexOf('CC') >= 0 ||
                  ffExoprtDetail.engJobType.indexOf('TPT') >= 0) &&
                (ffExoprtDetail.transportType == 'Export' ||
                  ffExoprtDetail.transportType == 'Import')
              "
            >
              <!-- v-if=" -->
              <!-- (ffExoprtDetail.engJobType.indexOf('FF') >= 0 || ffExoprtDetail.engJobType.indexOf('CC')  >= 0 || ffExoprtDetail.engJobType.indexOf('TPT') >= 0) &&
                ffExoprtDetail.transportType == 'Export' -->
              <b-form-radio
                v-if="
                  ffExoprtDetail.transportType == 'Export' ||
                  ffExoprtDetail.transportType == 'Import'
                "
                size="lg"
                value="MERGE"
                >Move Containers to Existing Assignment(Merge)</b-form-radio
              >
            </b>
            <b-form-radio size="lg" value="REMOVE"
              >Remove Assignment Containers</b-form-radio
            >
            <b-form-radio
              size="lg"
              value="MOVE"
              v-if="
                (ffExoprtDetail.engJobType.indexOf('FF') >= 0 ||
                  ffExoprtDetail.engJobType.indexOf('CC') >= 0 ||
                  ffExoprtDetail.engJobType.indexOf('TPT') >= 0) &&
                (ffExoprtDetail.transportType == 'Export' ||
                  ffExoprtDetail.transportType == 'Import')
              "
              >Move Containers(Location Change)</b-form-radio
            >
            <b-form-radio size="lg" value="CHANGE">Change Service Request</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <h6 class="error" v-if="actionType == 'MERGE'">
          Note : 1- Container Can be merged to only assignments in which selected
          container Types are available.
          <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2-
          Selected Container will be removed from this Assignment and will be added to
          selected Assignment.
          <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3-For
          TPT Refer Current Assignment.
        </h6>
        <h6 class="error" v-if="actionType == 'SPLIT'">
          Note : 1- A new assignment will be created for selected containers .
          <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2-
          It will fall only in FF Export Module..!
          <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3-
          For TPT & CC Refer Current Assignment.
        </h6>
        <h6 class="error" v-if="actionType == 'REMOVE'">
          Note : 1- Selected Container Will be Removed. .
          <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2-
          Container can be removed only if container number is not added
        </h6>
        <!-- <div class="d-block">
          <h6 class="error">Select Container to {{ actionType }}</h6>
        </div>-->
        <div v-if="actionType != 'CHANGE'">
          <table class="table table-sm table-bordered">
            <tbody>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Container Type</th>
                <th scope="col">Container No</th>
                <th scope="col">--</th>
              </tr>
              <tr v-for="(itm, idx) in containerDetails" :key="idx">
                <th
                  style="text-align: center; vertical-align: middle; width: 20px"
                  bgcolor="whiteSmoke"
                  scope="row"
                >
                  <b-form-checkbox
                    style="
                      padding: 0px !important;
                      line-height: 0px !important;
                      height: 0px !important;
                    "
                    size="lg"
                    class="ml-4"
                    v-if="itm.isSplitedOrMerged == '0'"
                    :disabled="
                      itm.isSplitedOrMerged != '0' ||
                      (actionType == 'REMOVE' && itm.containerNo) ||
                      (actionType == 'MERGE' && !itm.containerNo) ||
                      (actionType == 'SPLIT' && !itm.containerNo) ||
                      (actionType == 'MOVE' && !itm.containerNo)
                        ? true
                        : false
                    "
                    v-model="singleSelectContainer"
                    :value="itm.uniqueContainerId"
                    unchecked-value="0"
                    @change="checkNewJobType(itm)"
                  ></b-form-checkbox>
                </th>
                <td>{{ itm.containerType }}</td>
                <td>{{ itm.containerNo }}</td>
                <td>
                  <!-- {{itm.isSplitedOrMergedNew}} -->
                  <!-- {{itm}} -->
                  <span v-if="itm.splitedToOrMergedToAssigNo" class="error">
                    Container Moved From :{{ itm.fromSplitMergeAssignNo }} to :
                    {{ itm.splitedToOrMergedToAssigNo }} (
                    <b v-if="itm.isSplitedOrMergedNew == 1">Splited</b>
                    <b v-else-if="itm.isSplitedOrMergedNew == 2">Merged</b>
                    <b v-else-if="itm.isSplitedOrMergedNew == 3">Moved</b>
                    ) Updated Date({{ itm.split_merge_date_time }})
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-if="actionType == 'MERGE' || actionType == 'MOVE'">
            <md-layout md-gutter class="mt-2">
              <md-layout md-flex="40">
                <label for="clientId">Merge Assignment No.</label>

                <model-list-select
                  :list="validExecution"
                  @input="getSalesSeries"
                  id="clientName"
                  v-model="ffExoprtDetail.mergeToAssignmentId"
                  option-value="allModuleId"
                  option-text="mainSalesSeries"
                  placeholder="Select Assignment"
                ></model-list-select>
              </md-layout>
            </md-layout>
          </div>
        </div>
        <div v-if="actionType == 'CHANGE'">
          <hr />
          <h6>Select JOB to add</h6>
          <b-form-group>
            <b-form-checkbox-group
              id="checkbox-group-2"
              v-model="ffExoprtDetail.changedRequestJobType"
              name="flavour-2"
            >
              <b-form-checkbox
                :disabled="ShowJOB.includes(item) ? true : false"
                v-for="(item, indx) in jobTypeFromEnquiry"
                :key="indx"
                :value="item"
                
               @change="checkNewJobType(item)"
                >{{ item }}</b-form-checkbox
              >
            </b-form-checkbox-group>
          </b-form-group>
        </div>
        <b-button size="sm" class="mt-4" variant="outline-danger" @click="hideModalCon"
          >Close & Cancel</b-button
        >
        <!-- {{actionType}} -->
        <b-button
          v-if="
            ((actionType == 'MERGE' || actionType == 'MOVE') &&
              ffExoprtDetail.mergeToAssignmentId != '' &&
              singleSelectContainer.length > 0) ||
            ((actionType == 'CHANGE' ||
              actionType == 'SPLIT' ||
              actionType == 'REMOVE') &&
              singleSelectContainer.length > 0) ||
            actionType == 'CHANGE'
          "
          size="sm"
          class="mt-4 pull-right"
          variant="success"
          @click="mergeSplitAssignmentConfirm"
          >{{ actionType }}</b-button
        >
      </b-modal>
      <!-- Console Booking approval request modal -->
      <b-modal
        v-model="showCBApprovalModal"
        no-close-on-esc
        no-close-on-backdrop
        hide-footer
        title="Console Booking UNRELEASED Approval Request"
      >
        <div class="d-block">
          <p>
            Console Booking No:
            <strong>{{ ffExoprtDetail.validBookingNo || '-' }}</strong><br />
            <span v-if="ffExoprtDetail.mainSalesSeries">
            Assignment No:
            <strong>{{ ffExoprtDetail.mainSalesSeries || '-' }}</strong>
            <br /></span>
            Days Delayed:
            <strong>{{ diffInDays || '-' }}</strong><br />
            Release Date:
            <strong>{{ bookingDetails.ReleaseDate || '-' }}</strong>
            <br />
            <span v-if="bookingDetails.AppovalReleaseDate">
              Approval Date:
              <strong>{{ bookingDetails.AppovalReleaseDate || '-' }}</strong>
            </span>

          </p>

          <b-form-group label="Delay Reason *">
            <div class="d-flex align-items-center" style="gap: 8px;">
              <model-list-select
                :list="cbDelayReasonOptions.filter(o => o.value !== '')"
                v-model="cbApproval.delay_reason"
                option-value="value"
                option-text="text"
                placeholder="Select delay reason"
                @input="cbApproval.delay_reason_error = ''"
                style="flex: 1;"
              />
              <b-button
                variant="outline-primary"
                size="sm"
                @click="showAddReasonInput = !showAddReasonInput"
                title="Add new delay reason"
                style="white-space: nowrap;"
              >+ Add</b-button>
            </div>
            <div v-if="showAddReasonInput" class="mt-2 d-flex align-items-center" style="gap: 8px;">
              <b-form-input
                v-model="newDelayReason"
                placeholder="Enter new delay reason"
                style="flex: 1;"
                @keyup.enter="addNewDelayReason"
              />
              <b-button
                variant="primary"
                size="sm"
                :disabled="addDelayReasonLoading || !newDelayReason.trim()"
                @click="addNewDelayReason"
              >
                <b-spinner v-if="addDelayReasonLoading" small class="mr-1" />
                Save
              </b-button>
              <b-button
                variant="secondary"
                size="sm"
                @click="showAddReasonInput = false; newDelayReason = ''"
              >Cancel</b-button>
            </div>
            <span class="error" v-if="cbApproval.delay_reason_error">
              {{ cbApproval.delay_reason_error }}
            </span>
          </b-form-group>

          <b-form-group label="Delay Remark">
            <b-form-textarea
              v-model="cbApproval.delay_reason_remark"
              placeholder="Enter remark (optional)"
            />
          </b-form-group>

          <div class="text-right mt-3">
            <b-button
              variant="secondary"
              :disabled="cbApproval.isSubmitting"
              @click="showCBApprovalModal = false"
            >
              Cancel
            </b-button>
            <b-button
              variant="primary"
              class="ml-2"
              :disabled="cbApproval.isSubmitting"
              @click="sendCBApprovalRequest"
            >
              <span v-if="cbApproval.isSubmitting">
                <b-spinner small class="mr-1"></b-spinner>
                Sending...
              </span>
              <span v-else>Send Approval Request</span>
            </b-button>
          </div>
        </div>
      </b-modal>
      <b-modal
        no-close-on-esc
        no-close-on-backdrop
        ref="my-modal-confirm"
        hide-footer
        id="modal-multi-1"
        size="lg"
        title="Confirmation"
      >
        <h5 class="my-2 error">Confirmation..! </h5>
         <!-- {{ ffExoprtDetail.engJobType }}
        {{ ffExoprtDetail.changedRequestJobType.indexOf('FF') }}
        {{ isMultiBooking }} -->
        <div
          v-if=" 
            ((actionType == 'SPLIT' && ffAlreadyInAssignment) || (actionType == 'CHANGE' && !ffAlreadyInAssignment)) &&
            ((ffExoprtDetail.changedRequestJobType.indexOf('FF') >= 0 && isMultiBooking))
            

          "
        > 
       
        <!-- (ffExoprtDetail.engJobType.indexOf('FF') >=0 || (ffExoprtDetail.changedRequestJobType.indexOf('FF') >= 0 && isMultiBooking)) -->
          <label
            for="validBookingNo"
            v-if="
              ((actionType == 'SPLIT' && ffAlreadyInAssignment) || (actionType == 'CHANGE' && !ffAlreadyInAssignment))  &&
              ((ffExoprtDetail.changedRequestJobType.indexOf('FF') >= 0 && isMultiBooking)) &&
              (ffExoprtDetail.transportType == 'Export') &&
              ffExoprtDetail.shipmentType == 1 &&
              ffExoprtDetail.containerInfo == 'fcl'
            "
          >
            {{ ffExoprtDetail.transportType == "Import" ? " BL No." : " Booking No." }}<span class="error">*</span>
            <b-button
                  @click="
                    checkAllCBBTN();
                    getConsoleBooking();
                  "
                  v-if="
                    ((ffExoprtDetail.changedRequestJobType.indexOf('FF') >= 0 && isMultiBooking)) &&
                    ffExoprtDetail.transportType == 'Export' &&
                    ffExoprtDetail.shipmentType == 1 &&
                    ffExoprtDetail.containerInfo == 'fcl' &&
                    $sessionsStorage.get('nameUser') == 'Bhavneesh' &&
                    $sessionsStorage.get('designation') == 'Admin'
                  "
                  style="font-size: 0.775rem"
                  variant="outline-primary"
                  v-model="checkAllCBVal"
                  >{{ checkAllCBVal ? "Selected" : "Un-Selected" }}</b-button
                >
          </label>
          <multi-select
            v-if="
              
              ((ffExoprtDetail.changedRequestJobType.indexOf('FF') >= 0 && isMultiBooking)) &&
              // (ffExoprtDetail.transportType == 'Export') 
              (ffExoprtDetail.transportType == 'Export' || ffExoprtDetail.transportType == 'Import' || ffExoprtDetail.transportType == 'IMPORT')
              &&
              ffExoprtDetail.shipmentType == '1' &&
              ffExoprtDetail.containerInfo == 'fcl'
            "
            :options="ConsoleBookingList"
            :selected-options="items"
            v-model="ffExoprtDetail.validmultiBookingNo"
            placeholder="Select Booking Number"
            :multiple="true"
            @select="SelectmultiConsoleBooking"
          ></multi-select>
          <span class="error" v-if="ffExoprtDetail.validmultiBookingNoErr || !validBookingNo">{{
            ffExoprtDetail.validmultiBookingNoErr || "Booking No Required"
          }}</span>
        </div>

        <div v-if="actionType == 'CHANGE'">
          Assignment No. will change as per additional JOB selected..!
        </div>

        <b-button
          size="sm"
          class="mt-4"
          variant="outline-danger"
          @click="hideModalConfirm"
          >Close & Cancel</b-button
        >
        
        <b-button
          v-if="actionType != ''"
          :disabled="
          actionType == 'CHANGE' &&
        !ffAlreadyInAssignment &&
        ffExoprtDetail.changedRequestJobType.includes('FF') &&
        ffExoprtDetail.containerInfo === 'fcl' &&
        ffExoprtDetail.shipmentType === '1' &&
        (
          ffExoprtDetail.transportType === 'Export' ||
          ffExoprtDetail.transportType === 'Import' ||
          ffExoprtDetail.transportType === 'IMPORT'
        ) &&
        ffExoprtDetail.validmultiBookingNo.length <= 0"
          size="sm"
          class="mt-4 pull-right"
          variant="success"
          @click="mergeSplitAssignment"
          >{{ actionType }}</b-button
        >
      </b-modal>
      <b-modal
        no-close-on-esc
        no-close-on-backdrop
        ref="location-modal"
        hide-footer
        id="modal-multi-2"
        size="lg"
        :title="'Change Location Of  : ' + seriesNumber"
      >
        <!-- <h6>Change Location Of : {{seriesNumber}}</h6> -->
        <model-list-select
          :list="options1"
          v-model="objectItem"
          option-value="pickupLocation"
          option-text="pickupLocation"
          placeholder="select item"
        ></model-list-select>
        <b-button size="sm" class="mt-4" variant="outline-danger" @click="hideModalLoc"
          >Close & Cancel</b-button
        >
        <b-button
          size="sm"
          class="mt-4 ml-auto"
          variant="outline-success"
          @click="changeLocation"
          >Submit</b-button
        >
      </b-modal>

      <!-- Added By Priyanshu Singh Start -->
      <b-modal
        no-close-on-esc
        no-close-on-backdrop
        ref="assignmentCLose-confirm"
        hide-footer
        id="modal-multi-1"
        size="lg"
        title="Confirmation"
      >
        <div>Are you sure to close Assignment Billing ?</div>

        <b-button
          size="sm"
          class="mt-4"
          variant="outline-danger"
          @click="hideCloseBillingModalConfirm"
          >Close</b-button
        >
        <b-button
          v-if="actionType != ''"
          size="sm"
          class="mt-4 pull-right"
          variant="success"
          @click="closeBillOk('Yes')"
          >Save</b-button
        >
      </b-modal>

      <b-modal
        no-close-on-esc
        no-close-on-backdrop
        size="xl"
        ref="modal-Add-Open"
        hide-footer
        :title="'Enter Container Type and Volumes'"
      >
        <b-row v-if="ffExoprtDetail.clientType == '2'" class="mb-3">
          <b-col cols="12">
            <div
              class="client-input-section p-3 border rounded shadow-sm"
              style="background: #fdfdfd; border-left: 5px solid #27ae60 !important;"
            >
              <h6 class="mb-3 text-success font-weight-bold">
                <i class="fa fa-user-plus mr-1"></i> Convert Lead to Client - Details
              </h6>
              <b-row>
                <b-col md="4" class="mb-2">
                  <label class="small font-weight-bold">Client Name <span class="error">*</span></label>
                  <b-form-input
                    size="sm"
                    v-model="ffExoprtDetail.newClientName"
                    placeholder="Enter Client Name"
                    :disabled="true"
                  ></b-form-input>
                  <span class="error small" v-if="newClientNameError">{{ newClientNameError }}</span>
                </b-col>
                <b-col md="4" class="mb-2">
                  <label class="small font-weight-bold">Client Email <span class="error">*</span></label>
                  <b-form-input
                    size="sm"
                    v-model="ffExoprtDetail.newClientEmail"
                    placeholder="Enter Client Email"
                  ></b-form-input>
                  <span class="error small" v-if="newClientEmailError">{{ newClientEmailError }}</span>
                </b-col>
                <b-col md="4" class="mb-2">
                  <label class="small font-weight-bold">Contact No <span class="error">*</span></label>
                  <b-form-input
                    size="sm"
                    v-model="ffExoprtDetail.newClientPhoneNumber"
                    placeholder="Enter Contact No"
                    type="number"
                  ></b-form-input>
                  <span class="error small" v-if="newClientPhoneNumberError">{{ newClientPhoneNumberError }}</span>
                </b-col>
                <b-col md="4" class="mb-2">
                  <label class="small font-weight-bold">PAN No (AAAAA1234A) <span class="error"></span></label>
                  <b-form-input
                    size="sm"
                    v-model="ffExoprtDetail.newClientPan"
                    placeholder="Enter PAN"
                    @keyup="validateNewClientPan"
                    :formatter="capitalizeAll"
                  ></b-form-input>
                  <span class="error small" v-if="newClientPanError">{{ newClientPanError }}</span>
                </b-col>
                <b-col md="4" class="mb-2">
                  <label class="small font-weight-bold"
                    >TAN No (AAAA12345A) <span class="error">*</span></label
                  >
                  <b-form-checkbox
                    class="ml-2 d-inline-block small"
                    v-model="ffExoprtDetail.isTanNotApplicable"
                    @change="onTanNotApplicableChange"
                  >
                    Not Applicable
                  </b-form-checkbox>
                  <b-form-input
                    size="sm"
                    v-model="ffExoprtDetail.newClientTan"
                    placeholder="Enter TAN"
                    @keyup="validateNewClientTan"
                    :formatter="capitalizeAll"
                    :disabled="ffExoprtDetail.isTanNotApplicable"
                  ></b-form-input>
                  <span class="error small" v-if="newClientTanError">{{
                    newClientTanError
                  }}</span>
                </b-col>
                <!-- <b-col md="1" class="mb-2 pr-0">
                  <label class="small font-weight-bold">Code</label>
                  <b-form-input
                    size="sm"
                    v-model="ffExoprtDetail.newClientStateCode"
                    disabled
                  ></b-form-input>
                </b-col>
                <b-col md="3" class="mb-2">
                  <label class="small font-weight-bold">GSTN No (AAAAA1234A1Z5) <span class="error"></span></label>
                  <b-form-input
                    size="sm"
                    v-model="ffExoprtDetail.newClientGSTN"
                    placeholder="Enter GSTN"
                    @keyup="validateNewClientGSTN"
                    :formatter="capitalizeAll"
                  ></b-form-input>
                  <span class="error small" v-if="newClientGSTNError">{{ newClientGSTNError }}</span>
                </b-col>
                <b-col md="4" class="mb-2">
                  <label class="small font-weight-bold">Company Type <span class="error">*</span></label>
                  <model-list-select
                    size="sm"
                    :list="companyTypeList"
                    v-model="ffExoprtDetail.newClientCompType"
                    option-value="companyTypeVal"
                    option-text="companyTypeText"
                    placeholder="Select Company Type"
                  ></model-list-select>
                  <span class="error small" v-if="newClientCompTypeError">{{ newClientCompTypeError }}</span>
                </b-col> -->
                <!-- <b-col md="4" class="mb-2">
                  <label class="small font-weight-bold">State <span class="error">*</span></label>
                  <model-list-select
                    size="sm"
                    :list="stateDetail"
                    v-model="ffExoprtDetail.newClientState"
                    option-value="stateId"
                    option-text="stateName"
                    placeholder="Select State"
                    @input="onNewClientStateChange"
                  ></model-list-select>
                  <span class="error small" v-if="newClientStateError">{{ newClientStateError }}</span>
                </b-col> -->
                <b-col md="4" class="mb-2">
                  <label class="small font-weight-bold">Client Address <span class="error"></span></label>
                  <b-form-textarea
                    size="sm"
                    rows="2"
                    v-model="ffExoprtDetail.newClientAddress"
                    placeholder="Enter Client Address"
                  ></b-form-textarea>
                  <span class="error small" v-if="newClientAddressError">{{ newClientAddressError }}</span>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <table class="table table-sm table-bordered mt-2">
              <tbody style="background: white">
                <tr>
                  <th scope="col" style="width: 5px">SN.</th>
                  <th
                    scope="col"
                    style="width: 200px"
                    v-if="ffExoprtDetail.shipmentType == 1"
                  >
                    Container Type
                  </th>
                  <th
                    scope="col"
                    style="width: 200px"
                    v-if="ffExoprtDetail.shipmentType == 1"
                  >
                    Total Container
                  </th>
                  <th scope="col" style="width: 180px">Tues Val</th>
                  <th scope="col" style="width: 180px">Remark</th>
                  <th scope="col" style="width: 5px">
                    Actions
                    <b-button @click="addLeadCont(null)" size="sm">
                      <i class="fa fa-plus-circle ml-1"></i>
                    </b-button>
                  </th>
                </tr>

                <tr v-for="(item, index) in ContainerVolumesArr" :key="index">
                  <th scope="row">{{ index + 1 }}.</th>
                  <td v-if="ffExoprtDetail.shipmentType == 1">
                    <model-list-select
                      :list="$store.getters['common/getAllContainerTypeList']"
                      v-model="item.fk_cont_type_id"
                      option-value="containerTypeId"
                      option-text="containerType"
                      placeholder="Select Container Type"
                    ></model-list-select>
                    <span class="error" v-if="item.fk_cont_type_id_err ? true : false">{{
                      item.fk_cont_type_id_err
                    }}</span>
                  </td>
                  <td v-if="ffExoprtDetail.shipmentType == 1">
                    <b-form-input
                      :formatter="capitalizeAll"
                      v-model="item.tot_continer"
                      type="number"
                      placeholder="Enter Total COntainer"
                    ></b-form-input>
                    <span class="error" v-if="item.tot_continer_err ? true : false">{{
                      item.tot_continer_err
                    }}</span>
                  </td>
                  <td>
                    <b-form-input
                      :formatter="capitalizeAll"
                      v-model="item.continer_tues_val"
                      type="number"
                      placeholder="Enter TUES Volume"
                    ></b-form-input>
                    <span
                      class="error"
                      v-if="item.continer_tues_val_err ? true : false"
                      >{{ item.continer_tues_val_err }}</span
                    >
                  </td>
                  <td>
                    <b-textarea
                      rows="2"
                      :formatter="capitalizeAll"
                      v-model="item.continer_remark"
                      type="text"
                      placeholder="Enter Remark"
                    ></b-textarea>
                  </td>
                  <td>
                    <b-button v-if="index > 0" size="sm" @click="removeLeadCont(index)">
                      <i class="fa fa-minus-circle" aria-hidden="true"></i>
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>

          <b-col md="12" class="mx-auto" >
            <label>Client Document<span class="error">*</span></label>
            <ClientFileUploader
              :style="'height: 80px; background: darkgray; width: 100%'"
              :documentName="'Client_Multiple_Doc-'"
              :otherDocName="'Client_Multiple_Doc-'"
              :folderName="'CLIENTKYCDOC'"
              :accept="'*'"
              :assign_no="'CLIENTKYCDOC'"
              :multiple="true"
              v-model="client_doc"
              :state="Boolean(client_doc)"
              :fileAllModuleId="'0'"
            />
            <span class="error small" v-if="client_doc_err">{{ client_doc_err }}</span>
          </b-col>
          <b-col md="12" v-if="client_doc">
            <div v-if="client_doc">
              <b-button
                v-for="(item1, index) in client_doc.split(',')"
                :key="index"
                style="margin-left: 2px; font-size: 0.675rem"
                @click="item1 ? PrintValidity_Doc(item1) : ''"
                size="sm"
                variant="warning"
                class="mb-1"
                >{{ item1 ? "PDF" + (parseInt(index) + 1) : "" }}</b-button
              >
            </div>
          </b-col>

          <b-col cols="12" class="text-center">
            <b-button
              v-if="ContainerVolumesArr.length > 0"
              class="mt-3 sm"
              variant="success"
              @click="submitContainer"
              >Save</b-button
            >
            <b-button class="mt-3 sm" variant="outline-danger" @click="closeModal"
              >Close</b-button
            >
          </b-col>
        </b-row>
      </b-modal>
      <!-- Added By Priyanshu Singh End -->
    </div>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop22"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAddFF"
      ref="addPop"
    ></md-dialog-alert>

    <md-dialog-confirm
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      @close="updateClientNew"
      ref="addClient"
    ></md-dialog-confirm>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="closeBillOk"
      ref="addPopClose"
    ></md-dialog-confirm>

    <md-dialog-confirm
      :md-title="alert.title"
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      @close="sendExecutionTeam"
      ref="sendExecution"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect, MultiSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
// import clientForm from "../view/clients/addClient.vue";
import { globalPermissionStatus, GlobalGetLocation } from "../../helper/collection";
import FilterAgencyModal from "../allModuleForm/filterAgencyModal.vue";
import FilterCBModal from "../allModuleForm/filterCBModal.vue";
import ClientCard from "../common/clientCard.vue";
import ShipmentTrackCard from "../common/ShipmentTrackCard.vue";
import CommonService from "../../services/CommonService.js";
import NodeLockPannelService from "../../services/NodeLockPannelService.js";
import ClientFileUploader from "../common/ClientFileUploader.vue";

export default {
  beforeMount() {
    //  eventBus.$emit("formName",
    //  {
    // name:"Ajit"
    //  })
    if (globalPermissionStatus("Enquiry & Pricing")) {
      this.$store.dispatch("setCurrentRoute", "/allModuleForm/allModuleForm");
      this.getServicesData();
      this.getData();
      this.$store.dispatch(
        "common/setAllContainerTypeList",
        JSON.stringify({
          itemCode: "ContainerTypeList",
        })
      );
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    singleSelectContainer: {
      handler: function (newVal, oldVal) {
        let dummysplitContainerType = [];
        let dummysplitContainerTypeId = [];

        for (let p = 0; p < this.singleSelectContainer.length; p++) {
          let con = this.containerDetails.filter((y) => {
            return y.uniqueContainerId == this.singleSelectContainer[p];
          });

          if (con.length > 0) {
            dummysplitContainerType.push(con[0].containerType);
            dummysplitContainerTypeId.push(con[0].containerTypeId);
          }
        }
        if (dummysplitContainerType.length > 0) {
          this.validExecution = [];
          var count = {};
          dummysplitContainerType.forEach(function (i) {
            count[i] = (count[i] || 0) + 1;
          });
          this.splitContainerType = Object.keys(count).toString();
          this.splitContainerTypeCount = Object.values(count).toString();
          this.splitContainerTypeId = [...new Set(dummysplitContainerTypeId)].toString();
          let execValid = [];
          //   for (let s = 0; s < dummysplitContainerTypeId.length; s++) {
          if (this.actionType == "MERGE") {
            // && x.handoverLocationId == this.ffExoprtDetail.handoverLocationId
            console.log('Priyanshu PS=>',this.clientMergeExecutionData.filter((x) => {
              return (
                x.mainSalesSeries=='CC/Exp/MUN/80888/24-25'
                // (x.handoverLocationId !=null && x.handoverLocationId !='null' && x.handoverLocationId !=undefined && x.handoverLocationId!='undefined')
              );}),
              this.clientMergeExecutionData.filter((x) => {
              return (
                x.mainSalesSeries=='CC/Exp/MUN/80889/24-25'
                // (x.handoverLocationId !=null && x.handoverLocationId !='null' && x.handoverLocationId !=undefined && x.handoverLocationId!='undefined')
              );}),
              
            this.ffExoprtDetail.handoverLocationId);
            if(this.ffExoprtDetail.changedRequestJobType.join(',').indexOf('FF') >= 0){
              execValid = this.clientMergeExecutionData.filter((x) => {
                return (
                  // x.multipleContainerTypeId.includes(this.splitContainerTypeId) && // 24-11-2023
                  // x.pickupLocationId == this.ffExoprtDetail.pickupLocationId &&
                  // x.stuffingLocationId ==this.ffExoprtDetail.stuffingLocationId &&
                  // x.handoverLocationId == this.ffExoprtDetail.handoverLocationId &&
                  x.PORlocationId == this.ffExoprtDetail.PORlocationId &&
                  x.PODLocationId == this.ffExoprtDetail.PODLocationId &&
                  x.LPlocationId == this.ffExoprtDetail.LPlocationId &&
                  x.finalPlaceLocationId == this.ffExoprtDetail.finalPlaceLocationId &&
                  x.shippingId == this.ffExoprtDetail.shippingId
                );
              });
            }else{
                execValid = this.clientMergeExecutionData.filter((x) => {
                return (
                  (x.handoverLocationId == this.ffExoprtDetail.handoverLocationId || (x.handoverLocationId == null && this.ffExoprtDetail.handoverLocationId == ''))&& 
                  (x.PORlocationId == this.ffExoprtDetail.PORlocationId || (x.PORlocationId == null && this.ffExoprtDetail.PORlocationId == '')) &&
                  (x.LPlocationId == this.ffExoprtDetail.LPlocationId || (x.LPlocationId == null && this.ffExoprtDetail.LPlocationId == '')) 
                  // &&(x.shippingId == this.ffExoprtDetail.shippingId || (x.shippingId == null && this.ffExoprtDetail.shippingId == ''))
                );
                });
            }
          } else if (this.actionType == "MOVE") {
            execValid = this.clientMergeExecutionData.filter((x) => {
              // alert(x.pickupLocationId)
              return (
                // x.PODLocationId == this.ffExoprtDetail.PODLocationId &&
                // x.finalPlaceLocationId ==
                //   this.ffExoprtDetail.finalPlaceLocationId &&
                x.multipleContainerTypeId.includes(this.splitContainerTypeId) && // 24-11-2023
                // x.pickupLocationId == this.ffExoprtDetail.pickupLocationId &&
                // x.stuffingLocationId ==
                // this.ffExoprtDetail.stuffingLocationId &&
                x.handoverLocationId == this.ffExoprtDetail.handoverLocationId &&
                x.PORlocationId == this.ffExoprtDetail.PORlocationId
              );
            });
          }
          console.log(execValid, "uyiuyi");
          // }

          if (execValid.length > 0) {
            this.validExecution.push(...execValid);
          }
          console.log(this.validExecution);
        }
        console.log(this.splitContainerTypeCount);
      },

      deep: true,
    },
    ffExoprtDetail: {
      handler: function (newVal, oldVal) {
        //   if(this.ffExoprtDetail.validBookingNo){
        //   let string = this.ffExoprtDetail.validBookingNo.replace(/[^a-zA-Z0-9]/g,',');
        //   this.ffExoprtDetail.validBookingNo=string.toUpperCase()
        //  console.log(this.ffExoprtDetail.validBookingNo)
        //  }
        if (this.ffExoprtDetail.PORlocationId != "") {
          let array = this.IcdPOrtList.filter((x) => {
            return x.pickupId == newVal.PORlocationId;
          })[0];

          this.ffExoprtDetail.portType = array.locationType;
          // if (array.locationType != "Icd") {
          //   this.PortLoadList = this.IcdPOrtList;
          //   this.ffExoprtDetail.LPlocationId = newVal.PORlocationId;
          // }

          // this.deliveryTermsName[1].deliveryTermsText =
          //   "FOB_POR_ " + array.mainLocation;
        }

        // if (
        //   newVal.LPlocationId != "" &&
        //   this.ffExoprtDetail.allModuleId == ""
        // ) {
        //   let array1 = this.PortLoadList.filter(x => {
        //     return x.pickupId == newVal.LPlocationId;
        //   })[0];
        //   this.deliveryTermsName[2].deliveryTermsText =
        //     "FOB_LoadPort_ " + array1.pickupLocation;
        // }

        if (
          this.ffExoprtDetail.shipmentType == "Sea_Shipment" &&
          this.ffExoprtDetail.allModuleId == ""
        ) {
          if (newVal.containerInfo != "fcl" && this.ffExoprtDetail.allModuleId == "") {
            this.ffExoprtDetail.stuffingType = "warehouseStuffing";
          }
        }
        if (this.ffExoprtDetail.clientId != "") {
          this.factoryDetail = this.tempfactoryDetail.filter((x) => {
            return x.clientId == this.ffExoprtDetail.clientId;
          });

          if (
            this.ffExoprtDetail.transportType == "Export" &&
            this.ffExoprtDetail.clientType != "3"
          ) {
            this.ffExoprtDetail.exporterClientId = this.ffExoprtDetail.clientId;
          } else if (
            this.ffExoprtDetail.transportType == "Import" &&
            this.ffExoprtDetail.clientType != "3"
          ) {
            this.ffExoprtDetail.importerClientId = this.ffExoprtDetail.clientId;
          }
        }

        // if (this.ffExoprtDetail.commodityId != "") {
        //   let array = this.getCommodityData.filter(x => {
        //     return x.commodityId == this.ffExoprtDetail.commodityId;
        //   });
        //   this.CommodityCallback(array[0]);
        // }
        if (this.ffExoprtDetail.exporterClientId != "") {
          if (
            this.ffExoprtDetail.clientType == "3" &&
            this.newJobType.indexOf("TPT") < 0
          ) {
            this.getData("No");
          }
          let dummyExporter = this.getImporterExpo.filter((x) => {
            return x.clientId == this.ffExoprtDetail.exporterClientId;
          });
          if (dummyExporter.length > 0) {
            if (dummyExporter[0].clientName == "Others") {
              this.openExpoInput = true;
            } else {
              this.openExpoInput = false;
            }
          }
        }
        if (this.ffExoprtDetail.importerClientId != "") {
          let dummyImporter = this.getImporterExpo.filter((x) => {
            return x.clientId == this.ffExoprtDetail.importerClientId;
          });
          if (dummyImporter.length > 0) {
            if (dummyImporter[0].clientName == "Others") {
              this.openImpoInput = true;
            } else {
              this.openImpoInput = false;
            }
          }
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      bookingDetails: {},
      diffInDays: "",
      showPleaseWaitMsg: false,
      showUpdateButton: false,
      timmerMsg: "",
      checkCBNoButton: 2,
      checkAllCB: false,
      checkAllCBVal: 0,
      commodityTypeName: [
        {
          commodityTypeVal: "Hazardous",
          commodityTypeText: "DANGEROUS CARGO (HAZ)",
        },
        {
          commodityTypeVal: "Reefer",
          commodityTypeText: "TEMPERATUR CONTROLLED ( REEFER)",
        },
        {
          commodityTypeVal: "Others",
          commodityTypeText: "GENERAL (OTHERS)",
        },
      ],
      userId: "",
      seriesNumber: "",
      allModuleId: "",
      options1: [],
      objectItem: {},
      checkstatus: "0",
      allExistingData: [],
      showSameBookingError: "",
      showFactLocError: "",
      actionType: "",
      getLocSearchResults: [],
      singleSelectContainer: [],
      // Added By Priyanshu Singh Start
      SelectedNewJobType: [],
      ConsoleBookingList: [],
      ConsoleBookingListMSG: "",
      items: [],
      // Added By Priyanshu Singh End
      cbApproval: {
        delay_reason: "",
        delay_reason_remark: "",
        delay_reason_error: "",
        isSubmitting: false,
      },
      cbDelayReasonOptions: [{ value: "", text: "Select delay reason" }],
      newDelayReason: "",
      addDelayReasonLoading: false,
      showAddReasonInput: false,
      showCBApprovalModal: false,
      splitContainerType: "",
      splitContainerTypeId: "",
      splitContainerTypeCount: "",
      factoryModal: {
        locSearch: "",
        longitude: "",
        latitude: "",
        multiFactoryId: "",
        clientId: "",
        location: "",
        GSTIN1: "",
        factoryAddress1: "",
        factoryTitle: "",
      },
      airLineList: [],
      getColoaderNameList: [],
      containerDetails: [],
      openExpoInput: false,
      openImpoInput: false,
      isLoading: false,
      disableFactory: false,
      factoryDetail: [],
      tempfactoryDetail: [],
      execDoneData: [],
      fields: [
        {
          key: "jobType",
          mainkey: "jobType",
          label: "JobType Executed Already..! ",
          sortable: true,
          sortDirection: "ASC",
        },
      ],
      opnTPT: false,
      transportTypeName: [
        {
          transportTypeVal: "Export",
          transportTypeText: "Export",
        },
        {
          transportTypeVal: "Import",
          transportTypeText: "Import",
        },
        // {
        //   transportTypeVal: "Empty_Moment",
        //   transportTypeText: "Empty Moment"
        // }
      ],
      stuffingTypeName: [
        {
          stuffingTypeVal: "factoryStuffing",
          stuffingTypeText: "Factory Stuffing",
        },
        {
          stuffingTypeVal: "warehouseStuffing",
          stuffingTypeText: "Warehouse Stuffing",
        },
      ],

      containerInfoName: [
        {
          containerInfoVal: "fcl",
          containerInfoText: "FCL",
        },
        {
          containerInfoVal: "lcl",
          containerInfoText: "LCL",
        },
        {
          containerInfoVal: "FclConsolidation",
          containerInfoText: "FCL Consolidation",
        },
        {
          containerInfoVal: "LclConsolidation",
          containerInfoText: "LCL Consolidation",
        },
      ],
      cctypeList: [
        {
          ccTypeVal: "1",
          ccTypeTxt: "Pridel",
        },
        {
          ccTypeVal: "2",
          ccTypeTxt: "Outsourced",
        },
        {
          ccTypeVal: "3",
          ccTypeTxt: "Not Applicable",
        },
      ],
      deliveryModeName: [
        {
          deliveryModeVal: "CY_CY",
          deliveryModeText: "CY / CY",
        },
        {
          deliveryModeVal: "CY_RAMP",
          deliveryModeText: "CY / RAMP",
        },
        {
          deliveryModeVal: "CY_StoreDoor",
          deliveryModeText: "CY / Store Door",
        },
      ],
      deliveryTermsName: [
        {
          deliveryTermsVal: "ExWorks",
          deliveryTermsText: "EXWORKS",
        },
        {
          deliveryTermsVal: "FOB",
          deliveryTermsText: "FOB",
        },
        {
          deliveryTermsVal: "CIF",
          deliveryTermsText: "CIF",
        },
        {
          deliveryTermsVal: "DAP",
          deliveryTermsText: "DAP",
        },
        {
          deliveryTermsVal: "DDU",
          deliveryTermsText: "DDU",
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "CFR",
          deliveryTermsText: "CFR",
        },
        {
          deliveryTermsVal: "FCA",
          deliveryTermsText: "FCA",
        },
      ],
      deliveryTermsName_bak: [
        {
          deliveryTermsVal: "ExWorks",
          deliveryTermsText: "Ex-Works",
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "DAP",
          deliveryTermsText: "DAP",
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "FOB_POR",
          deliveryTermsText: "FOB_POR_",
        },
        {
          deliveryTermsVal: "FOB_LoadPort",
          deliveryTermsText: "FOB_LoadPort_",
        },
        {
          deliveryTermsVal: "FCA",
          deliveryTermsText: "FCA",
        },
        {
          deliveryTermsVal: "FAS",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "CFR",
          deliveryTermsText: "CFR",
        },
        {
          deliveryTermsVal: "CIF",
          deliveryTermsText: "CIF",
        },
        {
          deliveryTermsVal: "CIP",
          deliveryTermsText: "CIP",
        },
        {
          deliveryTermsVal: "CPT",
          deliveryTermsText: "CPT",
        },
        {
          deliveryTermsVal: "DAF",
          deliveryTermsText: "DAF",
        },
        {
          deliveryTermsVal: "DES",
          deliveryTermsText: "DES",
        },
        {
          deliveryTermsVal: "DEQ",
          deliveryTermsText: "DEQ",
        },
      ],

      showAdd: false,
      ffAlreadyInAssignment: false,
      _ffAlreadyInAssignmentModuleId: null,

      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },

      allAgentColoader: [],
      ffShippingArray: [],
      CommodityAll: {},
      autoClientName: {},
      freightNoOfContainers: [],
      multiContainer: [],
      ffExoprtDetail: {
        engJobType: "",
        newContainerFlow: "",
        changedRequestJobType: [],
        mergeToAssignmentId: "",
        multipleContainerTypeId: "",
        validBookingNo: "",
        validmultiBookingNo: [],
        mainEnquirySeries: "",
        coLoaderId: "",
        onAccountOf: "",
        freightNoOfContainers: "",
        BranchCode: "",
        multiContainer: [],
        allModuleId: "",
        mainEnquiryId: "",
        ffShippingWiseId: "",
        // tptEnquiry: [],
        // ffEnquiry: [],
        // ccEnquiry: [],
        ccType: "",
        tptType: "",
        tptClientStatus: "",
        ccClientStatus: "",
        ccCha: "",
        transporterName: "",
        allModuleId: "",
        transContainerTypeId: "",
        transContainerType: "",
        pickupLocationId: "",
        stuffingLocationId: "",
        handoverLocationId: "",
        containerId: "",
        clientId: "",
        shippingId: "",
        shipmentType: "2",
        transportType: "",
        stuffingType: "",
        containerInfo: "",
        PORlocationId: "",
        LPlocationId: "",
        PODLocationId: "",
        finalPlaceLocationId: "",
        deliveryMode: "",
        deliveryTerms: "",
        exporterClientId: "",
        importerClientId: "",
        //   commodityId: "",
        IMDGClass: "",
        commodityType: "",
        itemDescription: "",
        UNNumber: "",
        packingCode: "",
        temperatureRequired: "",
        otherComodity: "",
        remark: "",
        portType: "",
        jobType: [],
        noOfContainer: "",
        clientType: "1",
        currencyType: "1",
        agreedByingOceanRate: "0",
        agreedSellingOceanRate: "0",
        airportDeparture: "",
        airportDestination: "",
        cargoReceived: "",
        destinationModeAir: "",
        doorDestinationfpod: "",
        estimatedDate: "",
        newClientName: "",
        newClientEmail: "",
        newClientAddress: "",
        newClientPhoneNumber: "",
        ffClientStatus: "",
        otherExpoName: "",
        otherImpoName: "",
        SalesExecutionCreated: "",
        SalesExecutionUpdated: "",
        newClientPan: "",
        newClientTan: "",
        newClientCompType: "",
        newClientGSTN: "",
        newClientState: "",
        newClientStateCode: "",
        isTanNotApplicable: false,
      },
      newClientPanError: "",
      newClientTanError: "",
      newClientGSTNError: "",
      newClientStateError: "",
      newClientNameError: "",
      newClientEmailError: "",
      newClientPhoneNumberError: "",
      newClientCompTypeError: "",
      newClientAddressError: "",
      client_doc_err: "",
      transportTypeError: "",
      shipmentTypeError: "",
      clientIdError: "",
      clientTypeError: "",
      currencyTypeError: "",
      agreedByingOceanRateError: "",
      agreedSellingOceanRateError: "",
      pickupLocationIdError: "",
      stuffingLocationIdError: "",
      newClientNameError: "",
      newClientEmailError: "",
      newClientAddressError: "",
      newClientPhoneNumberError: "",
      handoverLocationIdError: "",
      //  transContainerTypeIdError: "",
      containerInfoError: "",
      shipmentTypeError: "",
      importerClientIdError: "",
      commodityTypeError: "",
      exporterClientIdError: "",
      stuffingTypeError: "",
      airportDepartureError: "",
      airportDestinationError: "",
      cargoReceivedError: "",
      destinationModeAirError: "",
      shippingIdError: "",
      PORlocationIdError: "",
      LPlocationIdError: "",
      PODLocationIdError: "",
      finalPlaceLocationIdError: "",

      deleteId: "",

      containerModal: {
        containerType: "",
        noOfContainer: "",
        containerTypeId: "",
      },
      shippingIdError: "",
      totalContainer: "",
      noOfContainerError: "",
      containerTypeIdError: "",

      fobReceiptName: "",
      fobLoadPortName: "",
      commodityArray: [],
      getPortData: ["Agra"],

      error: {
        clientNameError: "",
        toPortError: "",
        fromPortError: "",
        transhipmentNameError: "",
        addOneTranError: "",
      },
      getCLientData: ["gfdg"],
      getImporterExpo: ["gfdg"],
      factoryDetail: [],
      destinationDelieveryList: [
        {
          type: "upto Airport",
          val: "1",
        },
        {
          type: "DOOR",
          val: "2",
        },
      ],
      cargoReceivedList: [
        {
          type: "Airport",
          val: "1",
        },
        {
          type: "Warehouse",
          val: "2",
        },
      ],
      statusModal: {
        tptClientStatus: "",
      },
      statusList: [
        // {
        //   statusV: "0",
        //   statusT: "In Progress"
        // },
        {
          statusV: "1",
          statusT: "Approve",
        },
        {
          statusV: "2",
          statusT: "Reject",
        },
      ],
      clientMergeExecutionData: [],
      validExecution: [],
      clientTypeList: [
        {
          type: "Client",
          val: "1",
        },
        {
          type: "Lead",
          val: "2",
        },
        {
          type: "Overseas Agent",
          val: "3",
        },
         {
          type: "Consignee",
          val: "4",
        },
      ],
      currencyTypeList: [
        {
          type: "USD",
          val: "1",
        },
        {
          type: "INR",
          val: "2",
        },
      ],
      companyTypeList: [
        { companyTypeVal: "Propreitorship", companyTypeText: "Propreitorship" },
        { companyTypeVal: "Partnership", companyTypeText: "Partnership" },
        { companyTypeVal: "privateLimited", companyTypeText: "Private Limited" },
        { companyTypeVal: "publicLimited", companyTypeText: "Public Limited" },
        { companyTypeVal: "HUF", companyTypeText: "HUF" },
        { companyTypeVal: "LLP", companyTypeText: "LLP" },
      ],
      stateDetail: [],
      ShowJOB: "",
      factorySelectedAtEnquiry: "",
      showSegmentArray: [],
      jobTypeFromEnquiry: [],
      showOtherServiceArray: [],
      showAdditionalMoreTaskArray: [],
      driverNameDetail: ["iji"],
      editVar: {
        Inputval:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "New",
      },
      errorAtleastOne: "",

      ffExportError: [
        "Please Select Client Name",
        "Please Select Place of Receipt",
        "Please Select Load  Port Name",
        "Please Select Port  of Discharge",
        "Please Select final Delievery",
        "Please Select Commidity",
        "Please Select Stuffing type",
        "Please Select Delivery  Terms",
        "Please Select Delivery Mode",
        "Please Select Exporter Name",
        "Please Select Importer Name",
        "Please Select Shipment type",
        "Please Select FF Activity",
        "Please Select Container type",
        "Please Select Handover Location",
        "Please Select Stuffing Location",
        "Please Select Pickup Location",
        "Please Select Transport Type",
        "Please Select Shipping Line",
      ],
      ffExporterrorList: {
        clientId: "",
        PORlocationId: "",
        LPlocationId: "",
        PODLocationId: "",
        finalPlaceLocationId: "",
        //   commodityId: "",
        stuffingType: "",
        deliveryTerms: "",

        deliveryMode: "",
        exporterClientId: "",
        importerClientId: "",
        shipmentType: "",
        containerInfo: "",
        transContainerTypeId: "",
        handoverLocationId: "",
        stuffingLocationId: "",
        pickupLocationId: "",
        transportType: "",
        shippingId: "",
      },

      ContainerError: ["Please Select Container", "Please Enter No of Container"],
      containererrorList: {
        containerTypeId: "",
        noOfContainer: "",
      },
      getPortDischargeList: [],
      PortLoadList: [],
      AirPortLoadList: [],
      shipmentTypeList: [
        {
          shipmentTypeVal: "1",
          shipmentTypeText: "Sea",
        },
        {
          shipmentTypeVal: "2",
          shipmentTypeText: "Air",
        },
      ],
      allModuleIdNew:
        this.$sessionsStorage.get("editallModuleId") != "" ||
        this.$sessionsStorage.get("editallModuleId") != undefined
          ? this.$sessionsStorage.get("editallModuleId")
          : "",
      jobTypeSelectVal: false,
      otherServicesVal: false,

      getShippingLineData: ["zim"],
      getCommodityData: ["zim"],
      getContainerTypeData: ["zim"],
      getlocationListData: ["agra"],
      getAlllocationListData: [],
      getAlllocationListDataFactory: [],
      getAlllocationHandover: [],
      IcdPOrtList: [],
      AirIcdPOrtList: [],

      finalAllPlaceData: [],
      validate: true,
      clientNameError: "",
      addDriverError1: "",
      addTruckError4: "",
      ExecutionDisable: "",
      newJobType: [],
      ContainerVolumesArr: [],
      client_doc: "",
      docURL: URL_BASE_DOC,
      validBookingNo:"",
      fk_booking_id:"",
      isMultiBooking:false,
    };
  },

  created() {
    eventBus.$on("fileuploaded", (file) => {
      console.log("fileuploaded=>", file);
      this.client_doc = file;
    });
  },
  mounted() {},
  beforeDestroy() {
    // this.$sessionsStorage.set("editSalesExId", "");
  },
  destroyed() {},
  components: {
    // clientForm,
    DatePicker,
    ModelListSelect,
    MultiSelect,
    // Loading,
    CustomLoader,
    FilterAgencyModal,
    FilterCBModal,
    ClientCard,
    ShipmentTrackCard,
    ClientFileUploader,
  },
  computed: {
    DisableSubmit() {
      // if(this.newJobType.indexOf("FF") <= 0 && this.newJobType.indexOf("CC") <= 0 && this.newJobType.indexOf("TPT") <= 0){
      // if(
      // this.newJobType.length<=0 ||
      // !this.multiContainer[0].freghtContainersNo ||
      // !this.ffExoprtDetail.shipmentType ||
      // !this.ffExoprtDetail.transportType ||
      // !this.ffExoprtDetail.clientId ||
      // !this.ffExoprtDetail.containerInfo ||
      // !this.ffExoprtDetail.importerClientId ||
      // !this.ffExoprtDetail.exporterClientId ||
      // !this.ffExoprtDetail.stuffingType ||
      // !this.ffExoprtDetail.shippingId ||
      // !this.ffExoprtDetail.PORlocationId ||
      // !this.ffExoprtDetail.LPlocationId ||
      // !this.ffExoprtDetail.PODLocationId ||
      // !this.ffExoprtDetail.finalPlaceLocationId ||
      // !this.ffExoprtDetail.pickupLocationId ||
      // !this.ffExoprtDetail.handoverLocationId ||
      // !this.ffExoprtDetail.stuffingLocationId
      // ){
      // console.log("lp")
      // return true;
      // }else{
      // return false;
      // }
      // }else if(this.newJobType.indexOf("FF") <= 0 && this.newJobType.indexOf("CC") <= 0){
      // if(
      // this.newJobType.length<=0 ||
      // !this.multiContainer[0].freghtContainersNo ||
      // !this.ffExoprtDetail.shipmentType ||
      // !this.ffExoprtDetail.transportType ||
      // !this.ffExoprtDetail.clientId ||
      // !this.ffExoprtDetail.containerInfo ||
      // !this.ffExoprtDetail.importerClientId ||
      // !this.ffExoprtDetail.exporterClientId ||
      // !this.ffExoprtDetail.stuffingType ||
      // !this.ffExoprtDetail.PORlocationId ||
      // !this.ffExoprtDetail.LPlocationId ||
      // !this.ffExoprtDetail.PODLocationId ||
      // !this.ffExoprtDetail.finalPlaceLocationId ||
      // !this.ffExoprtDetail.finalPlaceLocationId
      // ){
      // console.log("m")
      // return true;
      // }else{
      // return false;
      // }
      // }else if(this.newJobType.indexOf("TPT") <= 0){
      // if(
      // this.newJobType.length<=0 ||
      // !this.multiContainer[0].freghtContainersNo ||
      // !this.ffExoprtDetail.shipmentType ||
      // !this.ffExoprtDetail.transportType ||
      // !this.ffExoprtDetail.clientId ||
      // !this.ffExoprtDetail.pickupLocationId ||
      // !this.ffExoprtDetail.handoverLocationId ||
      // !this.ffExoprtDetail.stuffingLocationId
      // ){
      // console.log("l")
      // return true;
      // }else{
      // return false;
      // }
      // }
    },
    clientList() {
      return this.getCLientData;
    },
    ContainerTypeList() {
      return this.getContainerTypeData;
    },
    shippingList() {
      return this.getShippingLineData;
    },
    locationList() {
      return this.getlocationListData;
    },
    IcdPOrtListNew() {
      return this.IcdPOrtList;
    },

    PortDischargeList() {
      return this.getPortDischargeList;
    },
    allLocationList() {
      return this.getAlllocationListData;
    },
    allLocationListFactory() {
      return this.getAlllocationListDataFactory;
    },
    PortList() {
      return this.getPortData;
    },
    viewDocument() {
      return this.ffExoprtDetail.uploadDriverDoc.split(",");
    },
    vehicleMasterList() {
      return this.driverNameDetail;
    },
    commodityList() {
      return this.getCommodityData;
    },

    transportTypeList() {
      return this.transportTypeName;
    },

    stuffingTypeList() {
      return this.stuffingTypeName;
    },

    containerInfoList() {
      return this.containerInfoName;
    },

    deliveryModeList() {
      return this.deliveryModeName;
    },

    deliveryTermsList() {
      return this.deliveryTermsName;
    },

    pdaDetailList() {
      return this.pdaDetailsName;
    },
    oceanFreightTermsList() {
      return this.oceanFreightTermsName;
    },
    prepaidDetailsList() {
      return this.prepaidDetailsName;
    },
    collectDetailsList() {
      return this.collectDetailsName;
    },

    agentNameList() {
      return this.getagentName;
    },
    // getColoaderNameList() {
    //   return this.getColoaderName;
    // },
  },
  methods: {
    PrintValidity_Doc(validity_doc) {
      if (!validity_doc) return;
      this.openSignedDocument(`CLIENTKYCDOC/${validity_doc}`);
    },
    // Added 01-02-2023 start
    removeLeadCont(index) {
      this.contractContainerArr.splice(index, 1);
    },
    AddMoreContactP() {
      let obj = {
        name: "",
        email: "",
        phone: "",
        dept: "",
        deg: "",
      };
      this.contactPersonArry.push(obj);
    },
    fetchNewClientState() {
      let payload = { state: "state", stateId: "" };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/fetchStateToClient.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          if (result.status == 200 && result.data) {
            this.stateDetail = result.data.statelist;
          }
        })
        .catch((error) => {});
    },
    onNewClientStateChange(event) {
      if (event) {
        let selectedState = this.stateDetail.find((x) => x.stateId == event);
        if (selectedState) {
          this.ffExoprtDetail.newClientStateCode = selectedState.gstCode;
        }
      }
    },
    validateNewClientPan() {
      var panFormat = new RegExp("^[A-Z]{5}[0-9]{4}[A-Z]{1}$");
      if (panFormat.test(this.ffExoprtDetail.newClientPan)) {
        this.newClientPanError = "";
      } else {
        this.newClientPanError = "Invalid PAN format";
      }
    },
    validateNewClientTan() {
      if (
        this.ffExoprtDetail.isTanNotApplicable ||
        this.ffExoprtDetail.newClientTan == "Not Applicable"
      ) {
        this.newClientTanError = "";
        return;
      }
      var tanFormat = new RegExp("^[A-Z]{4}[0-9]{5}[A-Z]{1}$");
      if (tanFormat.test(this.ffExoprtDetail.newClientTan)) {
        this.newClientTanError = "";
      } else {
        this.newClientTanError = "Invalid TAN format";
      }
    },
    onTanNotApplicableChange(val) {
      if (val) {
        this.ffExoprtDetail.newClientTan = "Not Applicable";
        this.newClientTanError = "";
      } else {
        this.ffExoprtDetail.newClientTan = "";
      }
    },
    validateNewClientGSTN() {
      var gstFormat = new RegExp("^[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$");
      if (gstFormat.test(this.ffExoprtDetail.newClientGSTN)) {
        this.newClientGSTNError = "";
      } else {
        this.newClientGSTNError = "Invalid GSTN format";
      }
    },
    AddPop() {
      this.$refs["addPop"].open();
    },
    checkLeadContData() {
      this.fetchNewClientState();
      const enabledValues = this.showSegmentArray
        .filter((item) => !item.isDisabled) // Filter items where isDisabled is false
        .map((item) => item.value);
      console.log("this.ffExoprtDetail=>", this.ffExoprtDetail, enabledValues);
      let LeadArr = this.$store.getters["common/getAllLeadCompList"].filter((x) => {
        return x.lead_comp_name == this.ffExoprtDetail.newClientName;
      });
      if (
        this.ffExoprtDetail.clientType == 2 &&
        (this.ffExoprtDetail.shipmentType == 1 ||
          this.ffExoprtDetail.shipmentType == 2) &&
        // enabledValues.indexOf("FF") >= 0 &&
        this.ffExoprtDetail.fk_lead_id > 0
      ) {
        // this.ContainerVolumesArr = [];
        this.$refs["modal-Add-Open"].show();
      } else if (
        this.ffExoprtDetail.clientType == 2 &&
        (this.ffExoprtDetail.shipmentType == 1 ||
          this.ffExoprtDetail.shipmentType == 2) &&
        this.ffExoprtDetail.fk_lead_id > 0
      ) {
        this.submitContainer();
      }
    },
    submitContainer() {
      this.ffExoprtDetail.ContainerVolumesArr = this.ContainerVolumesArr;
      this.ffExoprtDetail.client_doc = this.client_doc;

      // Reset Errors
      this.newClientNameError = "";
      this.newClientEmailError = "";
      this.newClientPhoneNumberError = "";
      this.newClientPanError = "";
      this.newClientTanError = "";
      this.newClientGSTNError = "";
      this.newClientCompTypeError = "";
      this.newClientStateError = "";
      this.newClientAddressError = "";
      this.client_doc_err = "";

      let validate = true;

      if (this.ffExoprtDetail.clientType == "2") {
        if (!this.ffExoprtDetail.newClientName) {
          this.newClientNameError = "Please Enter Client Name";
          validate = false;
        }
        if (!this.ffExoprtDetail.newClientEmail) {
          this.newClientEmailError = "Please Enter Email";
          validate = false;
        } else {
          var emailFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailFormat.test(this.ffExoprtDetail.newClientEmail)) {
            this.newClientEmailError = "Please Enter Valid Email";
            validate = false;
          }
        }
        if (!this.ffExoprtDetail.newClientPhoneNumber) {
          this.newClientPhoneNumberError = "Please Enter Contact No";
          validate = false;
        } else if (this.ffExoprtDetail.newClientPhoneNumber.length < 10) {
          this.newClientPhoneNumberError = "Please Enter Valid Contact No.";
          validate = false;
        }
        // if (!this.ffExoprtDetail.newClientPan) {
        //   this.newClientPanError = "Please Enter PAN No";
        //   validate = false;
        // } else {
        //   this.validateNewClientPan();
        //   if (this.newClientPanError) validate = false;
        // }
        if (!this.ffExoprtDetail.newClientTan) {
          this.newClientTanError = "Please Enter TAN No";
          validate = false;
        } else {
          this.validateNewClientTan();
          if (this.newClientTanError) validate = false;
        }
        // if (!this.ffExoprtDetail.newClientGSTN) {
        //   this.newClientGSTNError = "Please Enter GSTN No";
        //   validate = false;
        // } else {
        //   this.validateNewClientGSTN();
        //   if (this.newClientGSTNError) validate = false;
        // }
        // if (!this.ffExoprtDetail.newClientCompType) {
        //   this.newClientCompTypeError = "Please Select Company Type";
        //   validate = false;
        // }
        // if (!this.ffExoprtDetail.newClientState) {
        //   this.newClientStateError = "Please Select State";
        //   validate = false;
        // }
        if (!this.ffExoprtDetail.newClientAddress) {
          this.newClientAddressError = "Please Enter Address";
          validate = false;
        }

        if (!this.client_doc) {
          this.client_doc_err = "Please Upload Client Document";
          validate = false;
        }
      }

      if (!validate) {
        return;
      }
      // console.log("PS Sinha=>",this.ffExoprtDetail);
      //  return;

      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/updateClient.php`,
        data: JSON.stringify(this.ffExoprtDetail),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            $("#loader").css("display", "none");
            $("#addButtonLoader").css("display", "block");
            this.alert.content = "Your Client is Added into Client Master";
            this.closeModal();
            this.$refs["addPop"].open();
            this.getData();
          }
        })
        .catch((error) => {});
    },
    clearLeadCont() {
      this.ContainerVolumesArr = [];
    },
    closeModal() {
      // this.clearLeadCont();
      this.$refs["modal-Add-Open"].hide();
    },
    checkFFCONBookingNo() {
      if (this.ffExoprtDetail.validBookingNo != "") {
        let payload = {
          validBookingNo: this.ffExoprtDetail.validBookingNo,
          itemCode: "CheckBookingNumber",
        };

        this.timmerMsg = "Please Wait - Searching Booking Number";

        setTimeout(() => {
          CommonService.getCheckBLDetails(payload)
            .then((response) => {
              const { data, status, statusText } = response;
              if (data.exist != "" && data.exist != undefined) {
                this.timmerMsg = "";
                this.checkCBNoButton = data.exist;
              } else {
                // this.alert.content = data.MSG;
              }
              this.isLoading = false;
            })

            .catch((error) => {
              console.log("Catch on getDatacheck - CheckBookingNumber Error: ", error);
            });
        }, 2000);
      }
    },

    updateBookingNo() {
      if (this.ffExoprtDetail.validBookingNo == "") {
        this.alert.content = "Booking No is Required";
        this.$refs["addPop"].open();
        return false;
      }
      let obj = {
        validBookingNo: this.ffExoprtDetail.validBookingNo,
        allModuleId: this.ffExoprtDetail.allModuleId,
        jobType: this.ShowJOB,
        isConsolidation: this.ffExoprtDetail.isConsolidation,
      };
      if (this.ffExoprtDetail.allModuleId != "") {
        console.log(obj);
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_ConsoleBooking/updateallModuleBookingNo.php`,
          data: JSON.stringify(obj),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.allModuleId != "" && data.allModuleId != undefined) {
                if (data.find == 1) {
                  this.alert.content = data.MSG;
                } else {
                  this.alert.content = data.MSG;
                  this.validBookingNo = "";
                  this.allModuleId = "";
                }
              } else {
                this.alert.content = data.MSG;
              }
              this.$refs["addPop"].open();

              this.getServicesData();
              this.getData();
            }
          })
          .catch((error) => {});
      }
    },
    SelectmultiConsoleBooking(items, lastSelectItem) {
      console.log("Priyanshu Singh=>", items[0]);
      this.items = items;
      this.ffExoprtDetail.validmultiBookingNo = items;

      let book_no = "";
      items.forEach((element) => {
        if (book_no == "") {
          book_no = element.text;
        } else {
          book_no = book_no + "," + element.text;
        }
      });
      this.validBookingNo=book_no;
      this.fk_booking_id="";
      this.ffExoprtDetail.validBookingNo = book_no;
      console.log(
        "this.ffExoprtDetail.validBookingNo Priyanshu=>",
        this.ffExoprtDetail.validBookingNo
      );
    },
    async syncFFAlreadyInAssignmentFromApi() {
      const moduleId = this.ffExoprtDetail.allModuleId;
      console.log("syncFFAlreadyInAssignmentFromApi Enter",this.ffExoprtDetail,moduleId);
      if (!moduleId && (this.actionType == 'SPLIT' || this.actionType == 'CHANGE')) {
        this.ffAlreadyInAssignment = false;
        return;
      }
      console.log("syncFFAlreadyInAssignmentFromApi Condition",this._ffAlreadyInAssignmentModuleId === String(moduleId));
      if (this._ffAlreadyInAssignmentModuleId === String(moduleId)&&(this.actionType == 'SPLIT' || this.actionType == 'CHANGE')) {
        return;
      }
      console.log("syncFFAlreadyInAssignmentFromApi After Condition",this.ffAlreadyInAssignment);

      try {
        console.log("syncFFAlreadyInAssignmentFromApi try", this.ffAlreadyInAssignment);
        const response = await NodeLockPannelService.verifyContainerAssignmentJobType({
          allModuleId: moduleId,
          JobNo: this.ffExoprtDetail.mainSalesSeries || "",
        });
        const data = response.data || {};
        console.log("NodeLockPannelService=>",response)
        this.ffAlreadyInAssignment = !!data.hasFFInAssignment;
        if (data.assignmentJobType !== undefined && data.assignmentJobType !== null) {
          this.ffExoprtDetail.engJobType = String(data.assignmentJobType);
        }
        this._ffAlreadyInAssignmentModuleId = String(moduleId);
      } catch (error) {
        console.log("syncFFAlreadyInAssignmentFromApi error", error);
        const engJobType = String(this.ffExoprtDetail.engJobType || "");
        this.ffAlreadyInAssignment = engJobType.indexOf("FF") >= 0;
      }
    },
    async checkCBReleaseBeforeFFProceed(type) {
      console.log("checkCBReleaseBeforeFFProceed Enter",type,this.ffExoprtDetail);
      if(this.actionType == 'CHANGE'  ||this.actionType == 'SPLIT'){
        await this.syncFFAlreadyInAssignmentFromApi();
      }else if(!this.ffExoprtDetail.allModuleId){
        this.ffAlreadyInAssignment=true;
      }
      const newJobType = Array.isArray(this.newJobType) ? this.newJobType : [];
      const engJobType = String(this.ffExoprtDetail.engJobType || "");
      const changedRequestJobType = Array.isArray(
        this.ffExoprtDetail.changedRequestJobType
      )
        ? this.ffExoprtDetail.changedRequestJobType
        : [];
      const validMulti = Array.isArray(this.ffExoprtDetail.validmultiBookingNo)
        ? this.ffExoprtDetail.validmultiBookingNo
        : [];

      if(type == 2){
        if(!this.ffAlreadyInAssignment && this.actionType == 'SPLIT'){
          return { canProceed: true };
        }else if(this.ffAlreadyInAssignment && this.actionType == 'CHANGE' && this.ffExoprtDetail.changedRequestJobType.indexOf('FF') >= 0){
          return { canProceed: true };
        }
      }else if(type == 1){
        if (!this.ffAlreadyInAssignment) {
          return { canProceed: true };
        }
      }
      

      const isFFJob =
        newJobType.indexOf("FF") >= 0 ||
        engJobType.indexOf("FF") >= 0 ||
        changedRequestJobType.indexOf("FF") >= 0;
      console.log("isFFJob",newJobType,engJobType,changedRequestJobType,validMulti,isFFJob);
      // return false;
console.log("isFFJob transportType",this.ffExoprtDetail.transportType,this.ffExoprtDetail.shipmentType,this.ffExoprtDetail.containerInfo,isFFJob);
      if (
        !isFFJob &&
        this.ffExoprtDetail.transportType !== "Export" &&
        this.ffExoprtDetail.shipmentType !== 1 &&
        this.ffExoprtDetail.containerInfo !== "fcl"
      ) {
        return { canProceed: true };
      }

      if (
        !this.ffExoprtDetail.validBookingNo ||
        (validMulti.length > 0 && !validMulti[0].value)
      ) {
        this.alert.content = "Select Console Booking before proceeding.";
        this.$refs["addPopClose"].open();
        return { canProceed: false };
      }
      const payload = {
        booking_id:
          validMulti.length <= 0 ? this.fk_booking_id : validMulti[0].value,
        booking_no: this.ffExoprtDetail.validBookingNo,
      };

      try {
        const response = await NodeLockPannelService.checkNotProceedConsoleBookingJob(payload);
        const { data, status, statusText } = response;
        this.bookingDetails = data.data || {};
        this.diffInDays = data.diffInDays || 0;

        if (data && data.requireApproval) {
          this.alert.content = data.message || "Approval required for this Console Booking.";
          // this.$refs["addPop"].open();
          this.fetchDelayReasons();
          this.showCBApprovalModal = true;
          return { canProceed: false };
        }

        return { canProceed: true };
      } catch (err) {
        console.error("checkNotProceedConsoleBookingJob error", err);
        this.alert.content =
          "Unable to validate Console Booking. Please try again.";
        this.$refs["addPop"].open();
        return { canProceed: false };
      }
    },
    async fetchDelayReasons() {
      try {
        const response = await NodeLockPannelService.getDelayReasons();
        const { data } = response;
        if (data && data.success) {
          this.cbDelayReasonOptions = data.data;
        }
      } catch (err) {
        console.error("fetchDelayReasons error", err);
      }
    },
    async addNewDelayReason() {
      if (!this.newDelayReason.trim()) return;
      this.addDelayReasonLoading = true;
      try {
        const response = await NodeLockPannelService.addDelayReason({ reason: this.newDelayReason });
        const { data } = response;
        if (data && data.success) {
          await this.fetchDelayReasons();
          this.cbApproval.delay_reason = this.newDelayReason.trim();
          this.cbApproval.delay_reason_error = "";
          this.newDelayReason = "";
          this.showAddReasonInput = false;
        } else {
          this.alert.content = data.message || "Failed to add reason";
          this.$refs["addPop"].open();
        }
      } catch (err) {
        console.error("addNewDelayReason error", err);
      } finally {
        this.addDelayReasonLoading = false;
      }
    },
    async sendCBApprovalRequest() {
      if (!this.ffExoprtDetail.validBookingNo || (!this.ffExoprtDetail.validmultiBookingNo.length<=0&& !this.ffExoprtDetail.validmultiBookingNo[0].value)) {
        this.alert.content = "Console Booking not selected.";
        this.$refs["addPop"].open();
        return;
      }
      this.cbApproval.delay_reason_error = "";
      if (!this.cbApproval.delay_reason) {
        this.cbApproval.delay_reason_error = "Delay reason is required.";
        return;
      }

      const payload = {
        booking_id: this.ffExoprtDetail.validmultiBookingNo.length<=0 ? this.fk_booking_id : this.ffExoprtDetail.validmultiBookingNo[0].value,
        booking_no: this.ffExoprtDetail.validBookingNo,
        delay_reason: this.cbApproval.delay_reason,
        delay_reason_remark: this.cbApproval.delay_reason_remark,
        JobId: this.ffExoprtDetail.allModuleId,
        JobNo: this.ffExoprtDetail.mainSalesSeries,
        isJobExist: this.ffExoprtDetail.allModuleId ? "1" : "0",
      };

      this.cbApproval.isSubmitting = true;
      try {
        const response = await NodeLockPannelService.sendConsoleBookingApprovalRequest(payload);
        const { data, status, statusText } = response;
       
        this.alert.content = data.message || "Approval request sent.";
        this.$refs["addPop"].open();
        this.showCBApprovalModal = false;
      } catch (err) {
        console.error("sendConsoleBookingApprovalRequest error", err);
        this.alert.content = "Error sending approval request.";
        this.$refs["addPop"].open();
      } finally {
        this.cbApproval.isSubmitting = false;
      }
    },
    checkNewJobType(item) {
      if(this.ffExoprtDetail.changedRequestJobType.join(',').indexOf('FF') >= 0){
        item="FF";
      }
      if(item=="FF"){
        this.isMultiBooking=true;
      }

    },
    async mergeSplitAssignmentConfirm() {
      await this.syncFFAlreadyInAssignmentFromApi();
      // Check console booking release date for FF Export FCL before proceeding
      //  if (this.actionType == "CHANGE" && !this.ffAlreadyInAssignment) {
      //     const { canProceed } = await this.checkCBReleaseBeforeFFProceed(2);
      //     if (!canProceed) {
      //       return;
      //     }
      //   }
      // return false;

      this.ConsoleBookingList = [];
      if (this.actionType == "SPLIT" || this.actionType == "CHANGE") {
        if (
          !this.ffAlreadyInAssignment &&
          ((this.ffExoprtDetail.changedRequestJobType.indexOf("FF") >= 0 &&
            this.isMultiBooking) ||
            this.ffExoprtDetail.engJobType.indexOf("FF") >= 0 ||
            this.ffExoprtDetail.engJobType.indexOf("CC") >= 0 ||
            this.ffExoprtDetail.engJobType.indexOf("TPT") >= 0) &&
          (this.ffExoprtDetail.transportType == "Export" ||
            this.ffExoprtDetail.transportType == "Import") &&
          this.ffExoprtDetail.shipmentType == 1 &&
          this.ffExoprtDetail.containerInfo == "fcl"
        ) {
          this.ffExoprtDetail.validmultiBookingNo = [];
        }
        this.getConsoleBooking();
      }
      this.$refs["my-modal-confirm"].show();
    },
    changeOnRadio() {
      this.singleSelectContainer = [];
      this.ffExoprtDetail.changedRequestJobType = [];
      if (this.ShowJOB) {
        this.ffExoprtDetail.changedRequestJobType = this.ShowJOB.split(",");
      }
    },
    showModalCon(id) {
      this.singleSelectContainer = [];
      // this.actionType = id;
      this.fetchSMData();
    },
    showModalLoc(id) {
      this.singleSelectContainer = [];
      // this.actionType = id;
      this.getLocations();
    },
    hideModalLoc() {
      this.actionType = "";
      this.$refs["location-modal"].hide();
    },
    hideModalCon() {
      this.actionType = "";
      this.$refs["my-modal-con"].hide();
    },

    hideModalConfirm() {
      this.$refs["my-modal-confirm"].hide();
    },
    hideCloseBillingModalConfirm() {
      this.$refs["assignmentCLose-confirm"].hide();
      this.CommonmergeSplitAssignment();
    },

    fetchExistExec() {
      let new_data = {
        validBookingNo: this.ffExoprtDetail.validBookingNo,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/fetchSameExecBookingNo.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          console.log(result.data.status, "uy");
          if (result.data.status == "400") {
            this.showSameBookingError = "No Already Linked With Other Assignment";
            this.checkstatus = "0";
          } else {
            this.showSameBookingError = "";
            this.checkstatus = "0";
            console.log(this.showSameBookingError, "u");
          }
          if (result.data.allExistingData.length > 0) {
            this.allExistingData = result.data.allExistingData;
          }
        })
        .catch((error) => {});
    },
    fetchLoc() {
      let options = {
        method: "GET",
        url:
          `http://open.mapquestapi.com/nominatim/v1/search.php?key=OTLGZmcN6qXiHnH4qSU4lXTYWLPEoINP&format=json&q=city mall,andheri,india` +
          this.factoryModal.locSearch,
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      axios(options)
        .then((result) => {
          console.log(result.data);
          // getLocSearchResults
        })
        .catch((error) => {});
    },
    fetchLatLog() {
      let options = {
        method: "GET",
        url:
          // `https://www.mapquestapi.com/geocoding/v1/address?key=OTLGZmcN6qXiHnH4qSU4lXTYWLPEoINP&location=` +
          `https://www.mapquestapi.com/geocoding/v1/address?key=AiBjJ4PC52j31H0BO1xlTTXDHIAZwDD0&location=` +
          this.factoryModal.factoryAddress1,
      };

      axios(options)
        .then((result) => {
          console.log(result.data.results[0].locations[0].displayLatLng);
          this.factoryModal.latitude =
            result.data.results[0].locations[0].displayLatLng.lat;
          this.factoryModal.longitude =
            result.data.results[0].locations[0].displayLatLng.lng;
        })
        .catch((error) => {});
    },
    addClient(id) {
      if (
        this.ffExoprtDetail.clientType == "3" &&
        this.ffExoprtDetail.transportType == "Export"
      ) {
        this.factoryModal.clientId = this.ffExoprtDetail.exporterClientId;
      } else {
        this.factoryModal.clientId = this.ffExoprtDetail.clientId;
      }

      if (
        this.factoryModal.factoryTitle == "" ||
        this.factoryModal.latitude == "" ||
        this.factoryModal.longitude == ""
      ) {
        this.showFactLocError = "Please Enter all mandatory* Fields";
        return false;
      } else {
        this.showFactLocError = "";
      }

      let new_data = {
        buttonId: "AddFactory",
        factoryModal: this.factoryModal,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/addClientFactorySalesExecu.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          console.log(result);
          this.getData();
          Object.keys(this.factoryModal).map((x) => {
            this.factoryModal[x] = "";
          });
          this.$refs["my-modal"].hide();
        })
        .catch((error) => {});
    },

    showModal() {
      this.$refs["my-modal"].show();
    },
    showModalExist() {
      this.$refs["my-modal-exist"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    openLocationDialog() {
      this.$refs["dialogLocation"].open();
    },
    closeModalLocation() {
      this.getData();
      this.$refs["dialogLocation"].close();
    },
    removeContainerType(index) {
      this.multiContainer.splice(index, 1);
    },

    updateClient() {
      this.alert.content = "Are you sure you want to convert your lead to client?";
      this.$refs["addClient"].open();
    },

    updateClientNew(type) {
      if (type != "cancel") {
        this.checkLeadContData();
      }
    },

    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    doLoading() {
      this.isLoading = true;
    },

    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    fetchSMData() {
      let new_data = {
        itemCode: "itemCode",
        allModuleId: this.ffExoprtDetail.allModuleId,
        actionType: this.actionType,
        clientId: this.ffExoprtDetail.clientId,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/fetchSplitMergeData_NewV3.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          this.MyContainerUniqueIDARR = [];

          if (result.data.containerDetails.length > 0) {
            this.containerDetails = result.data.containerDetails;
          }
          if (result.data.clientMergeExecutionData.length > 0) {
            this.clientMergeExecutionData = result.data.clientMergeExecutionData;
          }

          this.$refs["my-modal-con"].show();
        })
        .catch((error) => {});
    },
    getLocations() {
      const option = {
        data: this.options1,
        categoryType: "hh",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/getLocationList.php`,
        data: JSON.stringify(option),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { data } = result;
          this.options1 = data.userDataList;
          this.$refs["location-modal"].show();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // To change location of FCL/LCLexport ,CC, TPT, SalesExecution
    changeLocation() {
      let location = this.seriesNumber.split("/");
      if (this.objectItem.BranchCode) {
        let series = `${location[0]}/${location[1]}/${this.objectItem.BranchCode}/${location[3]}/${location[4]}`;

        const option = {
          categoryType: "hh",
          userId: this.userId,
          location: series,
          objectItem: this.objectItem,
          pickupId: this.objectItem.pickupId,
          allModuleId: this.allModuleId,
          type: location[1],
          newLocation: series.replaceAll("/", "_"),
          oldLocation: this.seriesNumber.replaceAll("/", "_"),
        };
        console.log(option);
        let options = {
          method: "POST",
          url: `${URL_BASE}/updateLocation.php`,
          data: JSON.stringify(option),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { data } = result;
            this.getServicesData();
            this.getData();
            this.hideModalLoc();
            console.log(data);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        alert("please select loction!");
      }
    },
    getSalesSeries() {
      let ary = this.clientMergeExecutionData.filter((x) => {
        return x.allModuleId == this.ffExoprtDetail.mergeToAssignmentId;
      });
      if (ary.length > 0) {
        this.ffExoprtDetail.mergeToAssignmentNo = ary[0].mainSalesSeries;
      }
    },
    showMultiple() {
      this.ffExoprtDetail.additionalMoreTask.map((x) => {
        if (x.value == "OthersSpecify") {
          this.showAdd = true;
          return false;
        } else {
          this.showAdd = false;
        }
      });
    },

    getPortId1(item) {
      this.ffExoprtDetail.toportId = item.portId;
    },
    getPortId2(item) {
      this.ffExoprtDetail.fromportId = item.portId;
    },
    getPortId3(item) {
      this.transhipment.tentportId = item.portId;
    },

    // CommodityCallback(item) {
    //   this.ffExoprtDetail.commodityId = item.commodityId;
    //   this.ffExoprtDetail.commodityType = item.commodityType;
    //   this.ffExoprtDetail.itemDescription = item.itemDescription;
    // },
    otherServiceNameArraySelect(value, index) {
      if (value == "None") {
        if (this.otherServicesVal == false) {
          this.ffExoprtDetail.otherServices = Array(
            this.showOtherServiceArray.length
          ).fill(false);
          this.otherServicesVal = true;
        } else {
          this.ffExoprtDetail.otherServices = Array(
            this.showOtherServiceArray.length
          ).fill(false);
          this.otherServicesVal = false;
        }
        this.getServicesData();
      }
    },

    jobTypeSelect(value, index) {
      let i = this.newJobType.indexOf(value);
      this.ffExoprtDetail.validmultiBookingNo = [];
      this.items = [];
      this.ffExoprtDetail.validBookingNo = "";
      console.log("Happy=>", this.ffExoprtDetail.validmultiBookingNo);
      if (i >= 0) {
        this.newJobType.splice(i, 1);
      } else {
        this.newJobType.push(value);
        this.newJobType.push(this.newJobType.splice(this.newJobType.indexOf("CC"), 1)[0]);
        this.newJobType.push(
          this.newJobType.splice(this.newJobType.indexOf("TPT"), 1)[0]
        );
        this.newJobType.push(this.newJobType.splice(this.newJobType.indexOf("FF"), 1)[0]);
      }
      this.showSegmentArray.forEach((element) => {
        let ij = this.SelectedNewJobType.indexOf(element.value);
        // console.log("element=>",element);
        // console.log("value=>",value);
        if (ij >= 0) {
          this.SelectedNewJobType.splice(ij, 1);
        } else {
          if (element.value == value) {
            this.SelectedNewJobType.push(element.value);
          }
        }
      });
      this.SelectedNewJobType = [...new Set(this.SelectedNewJobType)];
      // segmentNameArray.value
      // this.SelectedNewJobType = this.newJobType;
    },
    JqueryFun() {
      return $(function () {
        return $("#FreghtContaner").DataTable();
      });
    },
    clientFilter(list, query) {
      return this.getCLientData.filter((x) => {
        return x.clientName.toLowerCase().includes(query.toLowerCase());
      });
    },
    PortFilter(list, query) {
      return this.getPortData.filter((x) => {
        return x.portName.toLowerCase().includes(query.toLowerCase());
      });
    },
    validateFFExport() {
      let validate_new = true;

      if (this.ffExoprtDetail.clientId == "" && this.ffExoprtDetail.clientType == "1") {
        $("#clientId").focus();
        this.clientIdError = "Select client name";
        console.log(this.clientIdError)
        validate_new = false;
      }

      // if (this.ffExoprtDetail.currencyType == "" && !this.showSegmentArray[0].isDisabled  && this.ffExoprtDetail.jobType[0]) {
      //   console.log("currancy")
      //   $("#currencyType").focus();
      //   this.currencyTypeError = "Select Currency Type";
      //   validate_new = false;
      // }

      // if (this.ffExoprtDetail.agreedByingOceanRate == ""  && !this.showSegmentArray[0].isDisabled && this.ffExoprtDetail.jobType[0]) {
      //   console.log("currancy")

      //   $("#agreedByingOceanRate").focus();
      //   this.agreedByingOceanRateError = "Select Agreed Buying Ocean Rate";
      //   validate_new = false;
      // }

      // if (this.ffExoprtDetail.agreedSellingOceanRate == ""  && !this.showSegmentArray[0].isDisabled && this.ffExoprtDetail.jobType[0]) {
      //   console.log("currancy")

      //   $("#agreedSellingOceanRate").focus();
      //   this.agreedSellingOceanRateError = "Select Agreed Selling Ocean Rate";
      //   validate_new = false;
      // }

      if (this.ffExoprtDetail.clientType == "") {
        $("#clientType").focus();
        this.clientTypeError = "Select client type";
        console.log(this.clientTypeError)
        validate_new = false;
      }

      if (this.ffExoprtDetail.transportType == "") {
        $("#transportType").focus();
        this.transportTypeError = "Select Transport Type";
        console.log(this.transportTypeError)
        validate_new = false;
      }
      if (this.ffExoprtDetail.shipmentType == "") {
        $("#transportType").focus();
        this.shipmentTypeError = "Select Shipment Type";
        console.log(this.shipmentTypeError)
        validate_new = false;
      }

      if (
        this.ffExoprtDetail.pickupLocationId == "" &&
        this.ffExoprtDetail.shipmentType == "1" &&
        this.newJobType.indexOf("TPT") >= 0
      ) {
        $("#pickupLocationId").focus();
        this.pickupLocationIdError = "Select Pickup Location";
        console.log(this.pickupLocationIdError)
        validate_new = false;
      }
      if (
        this.ffExoprtDetail.stuffingLocationId == "" &&
        this.ffExoprtDetail.shipmentType == "1" &&
        this.newJobType.indexOf("TPT") >= 0
      ) {
        $("#stuffingLocationId").focus();
        this.stuffingLocationIdError = "Select Factory  Location";
        console.log(this.stuffingLocationIdError)
        validate_new = false;
      }

      if (
        this.ffExoprtDetail.handoverLocationId == "" &&
        this.ffExoprtDetail.shipmentType == "1" &&
        this.newJobType.indexOf("TPT") >= 0
      ) {
        $("#handoverLocationId").focus();
        this.handoverLocationIdError = "Select Handover Location";
        console.log(this.handoverLocationIdError)
        validate_new = false;
      }
      // if (
      //   this.ffExoprtDetail.transContainerTypeId == "" &&
      //   this.newJobType.indexOf("TPT") >= 0
      // ) {
      //   $("#transContainerTypeId").focus();
      //   this.transContainerTypeIdError = "Select Container Type";
      //   validate_new = false;
      // }

      if (
        (this.newJobType.indexOf("CC") >= 0 && this.ffExoprtDetail.shipmentType == "1") ||
        (this.ffExoprtDetail.shipmentType == "1" && this.newJobType.indexOf("FF") >= 0)
      ) {
        console.log("Select FF Activity",this.ffExoprtDetail)
        if (this.ffExoprtDetail.containerInfo == "" && this.ffExoprtDetail.shipmentType == "1") {
          $("#containerInfo").focus();
          this.containerInfoError = "Select FF Activity";
          validate_new = false;
        }

        if (this.ffExoprtDetail.shipmentType == "") {
          $("#shipmentType").focus();
          this.shipmentTypeError = "Select Shipping Type";
          validate_new = false;
        }

        if (this.ffExoprtDetail.importerClientId == "") {
          $("#importerClientId").focus();
          this.importerClientIdError = "Select Importer Name";
          validate_new = false;
        }

        if (this.ffExoprtDetail.shipmentType == "1") {
          console.log(this.newJobType.join(","));
          let jobTypeDEtails = this.newJobType.join(",");
          if (jobTypeDEtails.indexOf("FF") >= 0) {
            if (this.ffExoprtDetail.commodityType == "") {
              this.commodityTypeError = "Select Commodity Type";
              validate_new = false;
            }
          }
        }
        // if (this.ffExoprtDetail.commodityId == "") {
        //   $("#commodityType").focus();
        //   this.commodityTypeError = "Select Commodity";
        //   validate_new = false;
        // }

        if (this.ffExoprtDetail.exporterClientId == "") {
          $("#exporterClientId").focus();
          this.exporterClientIdError = "Select Exporter Name";
          validate_new = false;
        }

        if (
          this.ffExoprtDetail.stuffingType == "" &&
          this.ffExoprtDetail.shipmentType == "1"
        ) {
          $("#stuffingType").focus();
          this.stuffingTypeError = "Select Stuffing Type";
          validate_new = false;
        }
        if (this.ffExoprtDetail.shippingId == "") {
          $("#shippingId").focus();
          this.shippingIdError = "Select Shipping Line";
          validate_new = false;
        }
        if (!this.ffExoprtDetail.PORlocationId) {
          $("#PORlocationId").focus();
          this.PORlocationIdError = "Select Place Of Receipt";
          validate_new = false;
        }
        if (!this.ffExoprtDetail.LPlocationId) {
          $("#LPlocationId").focus();
          this.LPlocationIdError = "Select Load Port";
          validate_new = false;
        }
        if (this.ffExoprtDetail.PODLocationId == "") {
          $("#PODLocationId").focus();
          this.PODLocationIdError = "Select Port Of Discharge";
          validate_new = false;
        }
        if (this.ffExoprtDetail.finalPlaceLocationId == "") {
          $("#finalPlaceLocationId").focus();
          this.finalPlaceLocationIdError = "Select Final Place Of Delivery";
          validate_new = false;
        }
      }

      if (this.ffExoprtDetail.shipmentType == "2" && this.newJobType.indexOf("FF") >= 0) {
        if (this.ffExoprtDetail.importerClientId == "") {
          $("#importerClientId").focus();
          this.importerClientIdError = "Select Importer Name";
          console.log(this.importerClientIdError)
          validate_new = false;
        }

        if (this.ffExoprtDetail.exporterClientId == "") {
          $("#exporterClientId").focus();
          this.exporterClientIdError = "Select Exporter Name";
          console.log(this.exporterClientIdError)
          validate_new = false;
        }

        if (this.ffExoprtDetail.airportDeparture == "") {
          $("#airportDeparture").focus();
          this.airportDepartureError = "Select Airport Departure";
          console.log(this.airportDepartureError)
          validate_new = false;
        }

        if (this.ffExoprtDetail.airportDestination == "") {
          $("#airportDestination").focus();
          this.airportDestinationError = "Select Airport Departure";
          console.log(this.airportDestinationError)
          validate_new = false;
        }
        if (this.ffExoprtDetail.cargoReceived == "") {
          $("#cargoReceived").focus();
          this.cargoReceivedError = "Select Cargo Received";
          console.log(this.cargoReceivedError)
          validate_new = false;
        }

        if (this.ffExoprtDetail.destinationModeAir == "") {
          $("#destinationModeAir").focus();
          this.destinationModeAirError = "Select Cargo Received";
          console.log(this.destinationModeAirError)
          validate_new = false;
        }
      }

      if (this.ffExoprtDetail.clientType == "2" &&  this.ffExoprtDetail.shipmentType == "1") {
        if (this.ffExoprtDetail.newClientName == "") {
          $("#newClientName").focus();
          this.newClientNameError = "Enter Client Name";
          console.log(this.newClientNameError)
          validate_new = false;
        } else {
          this.newClientNameError = "";
        }

        if (this.ffExoprtDetail.newClientPhoneNumber == "") {
          $("#newClientPhoneNumber").focus();
          this.newClientPhoneNumberError = "Enter Contact Number";
          console.log(this.newClientPhoneNumberError)
          validate_new = false;
        } else {
          this.newClientNameError = "";
        }
        if (this.ffExoprtDetail.newClientEmail == "") {
          $("#newClientEmail").focus();
          this.newClientEmailError = "Enter Client Email";
          console.log(this.newClientEmailError)
          validate_new = false;
        } else {
          this.newClientNameError = "";
        }
        if (this.ffExoprtDetail.newClientAddress == "") {
          $("#newClientAddress").focus();
          this.newClientAddressError = "Enter Client Address";
          console.log(this.newClientAddressError)
          validate_new = false;
        } else {
          this.newClientNameError = "";
        }
      }

      if (validate_new != true) {
        if (this.commodityArray.length > 0) {
          window.scroll(0, 40);
        }
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    async addFFExport() {
      // if (this.ffExoprtDetail.agreedByingOceanRate=="" && this.ffExoprtDetail.agreedSellingOceanRate=="" && !this.showSegmentArray[0].isDisabled  && this.ffExoprtDetail.jobType[0]) {
      //     this.alert.content = "Please Select AGREED BUYING & SELLING OCEAN RATES";
      //     this.$refs["addPop22"].open();
      //     return false;
      //   }

      if (this.newJobType.length <= 0) {
        console.log(this.newJobType);
        // this.alert.content = "Select At least 1 JobType";
        this.$refs["addPop22"].open();
        return false;
      }

      if (!this.newJobType.includes("FF") && this.ffExoprtDetail.clientType == "3") {
        console.log(this.newJobType.indexOf("FF"), "ty");
        this.alert.content =
          "Overseas Agent Execution must include Freight Forwarding..!   Please Select Freight to continue";
        this.$refs["addPop22"].open();
        return false;
      }
      if (this.ffExoprtDetail.shipmentType == "1") {
        this.ffExoprtDetail.airlineId = "0";
      } else {
        this.ffExoprtDetail.shippingId = "0";
      }

      if (this.multiContainer.length > 0) {
        let blankCon = this.multiContainer.filter((y) => {
          return (
            y.freghtContainersNo == undefined ||
            y.freghtContainersNo == "" ||
            y.freghtContainersNo == "0" ||
            y.freghtContainersNo <= "0"
          );
        });

        let errCount = 0;
        if (this.multiContainer.length > 0) {
          for (let j = 0; j < this.multiContainer.length; j++) {
            if ($.isNumeric(this.multiContainer[j].freghtContainersNo) == false) {
              ++errCount;
              break;
            }
          }

          if (errCount > 0) {
            this.alert.content = "Please Enter Only Numbers In No. of Container Details";
            this.$refs["addPop22"].open();
            return false;
          }
          // alert(errCount);
          //   this.multiContainer.forEach(function (key, val) {
          //   console.log("multiContainer key", key.freghtContainersNo);
          //   console.log("multiContainer val", val);
          //   // let valCont = this.isNumber(key.freghtContainersNo);
          //   let valCont = $.isNumeric(key.freghtContainersNo);
          //   alert(valCont);

          // });
          // let isString = this.multiContainer.filter((y) => {
          //   return !isNaN(parseFloat(y.freghtContainersNo)) && isFinite(y.freghtContainersNo)
          // });
        }

        if (blankCon.length > 0) {
          this.alert.content = "Please Enter all Container  Details";
          this.$refs["addPop22"].open();
          return false;
        }
        // alert(isString);
        // return false;
        // if (
        //   this.multiContainer[0].freghtContainersNo == undefined ||
        //   this.multiContainer[0].freghtContainersNo == ""
        // ) {
        //   this.alert.content = "Please Enter Container Details";
        //   this.$refs["addPop22"].open();
        //   return false;
        // }
      }

      this.ffExoprtDetail.mainEnquiryId = this.$sessionsStorage.get("editMainEnqId");
      this.ffExoprtDetail["multiContainer"] = this.multiContainer;

      this.validateFFExport();

      if (this.ffExoprtDetail.clientIsActive == "2") {
        this.alert.content = "First add into client Master";
        this.$refs["addPop22"].open();
        return false;
      }
      if (this.ffExoprtDetail.isKYC == "No") {
        this.alert.content = "Complete the KYC";
        this.$refs["addPop22"].open();
        return false;
      }
      if (
        this.ffExoprtDetail.exporterClientId == "" &&
        this.ffExoprtDetail.clientType == "3" &&
        this.ffExoprtDetail.transportType == "Export"
      ) {
        this.alert.content = "Please Select Exporter";
        this.$refs["addPop22"].open();
        return false;
      }
      let newVal = [];
      this.showSegmentArray.map((x, index) => {
        if (this.ffExoprtDetail.jobType[index] == true) {
          newVal.push(x.value);
        }
      });

      if (
        this.newJobType.indexOf("TPT") >= 0 &&
        this.ffExoprtDetail.shipmentType == "1" &&
        this.ffExoprtDetail.stuffingLocationId == ""
      ) {
        // let array = this.factoryDetail.filter(x => {
        //   return x.location == this.ffExoprtDetail.stuffingLocationId;
        // });
        // if (array.length == 0) {

        this.alert.content = "Please add Valid Factory Location ";
        this.$refs["addPop22"].open();

        return false;
        // }
      }

      if (
        this.newJobType.indexOf("CC") >= 0 &&
        this.ffExoprtDetail.shipmentType == "1" &&
        (this.ffExoprtDetail.PODLocationId == 0 ||
          this.ffExoprtDetail.PORlocationId == 0 ||
          this.ffExoprtDetail.finalPlaceLocationId == 0)
      ) {
        this.alert.content = "Please Select POR,Load Port,POD and FPOD  ";
        this.$refs["addPop22"].open();
        return false;
      }

      if (this.validate != false && this.ffExoprtDetail.jobType.length > 0) {
        // For FF Export FCL, block if CB approval required (release_date > 3 days)
        const { canProceed } = await this.checkCBReleaseBeforeFFProceed(1);
        // alert(canProceed)
        if (!canProceed) {
          return false;
        }
        // alert("canProceed",canProceed);
        // return false;

        this.alert.content =
          "Do you want  to send this Execution to Team? \n" +
          "Booking No :" +
          this.ffExoprtDetail.validBookingNo;
        this.$refs["sendExecution"].open();
      } else {
        console.log(this.validate, this.ffExoprtDetail.jobType.length,"PS");
        // this.alert.content = "Select At least 1 JobType";
        this.$refs["addPop22"].open();
        return false;
      }
    },

    onCloseAddFF() {
      this.$router.push({
        path: "/viewAllModuleDetails/viewAllModuleDetails",
      });
    },
    async closeBillOk(type) {
      console.log("CloseType=>", type);
      let incompleteJobBill = "";
      let closingReason = "";
      if(this.actionType == 'SPLIT' && this.ffAlreadyInAssignment){
        const { canProceed } = await this.checkCBReleaseBeforeFFProceed(2);
        if (!canProceed) {
          return false;
        }
      }
      if (type == "Yes") {
        incompleteJobBill = "InVoices Done";
      } else {
        this.CommonmergeSplitAssignment();
      }
      if (incompleteJobBill == "InVoices Done") {
        closingReason = "Direct Close By Sales Execution InVoices Done";
      }
      // return false;
      // alert(type);
      if (type == "Yes") {
        if (closingReason) {
          this.isLoading = true;
          let payload = {
            type: "sales_merge_page",
            allModuleId: this.ffExoprtDetail.allModuleId,
            closingReason: closingReason,
          };
          console.log(payload);

          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_Common/closeSalesBillingStatus.php`,
            data: JSON.stringify(payload),
            crossDomain: true,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };
          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              if (status == 200 && data) {
                this.getData();
                this.isLoading = false;
                // this.CommonmergeSplitAssignment();
                this.hideCloseBillingModalConfirm();
              }
            })
            .catch((error) => {});
        }
      }
    },
    async mergeSplitAssignment() {
      // Changes By Priyanshu Singh Start
      if (this.actionType == "SPLIT" || this.actionType == "CHANGE") {
        await this.syncFFAlreadyInAssignmentFromApi();
        if(this.actionType == "SPLIT"){
          this.isMultiBooking=true;
        }
        if (
          (!this.ffAlreadyInAssignment) &&
          (!this.ffExoprtDetail.validBookingNo ||
            !this.ffExoprtDetail.validmultiBookingNo ||
            this.ffExoprtDetail.validmultiBookingNo.length <= 0) &&
          (this.ffExoprtDetail.engJobType.indexOf("FF") >= 0 || (this.ffExoprtDetail.changedRequestJobType.indexOf('FF') >= 0 && this.isMultiBooking)) &&
          (this.ffExoprtDetail.transportType == "Export") &&
          this.ffExoprtDetail.shipmentType == 1 &&
          this.ffExoprtDetail.containerInfo == "fcl"
        ) {
          this.ffExoprtDetail.validmultiBookingNoErr = "Select At Least 1 Booking No";
          return false;
        } else {
          this.ffExoprtDetail.validmultiBookingNoErr = "";
        }
      }
      
      if (
        this.actionType == "SPLIT" ||
        this.actionType == "MOVE" ||
        this.actionType == "MERGE"
      ) {
        var ContainerARR = [];
        var ContainerUniqueIDARR = [];
        this.containerDetails.forEach(function (key, val) {
          console.log("key", key);
          console.log("val", val);
          if (key.containerNo != "") {
            if (key.isSplitedOrMerged == 0) {
              ContainerARR.push(key.containerNo);
              ContainerUniqueIDARR.push(key.uniqueContainerId);
            }
          }
        });
        this.singleSelectContainer.forEach(function (key, val) {
          ContainerUniqueIDARR.splice(ContainerUniqueIDARR.indexOf(key), 1);
        });
        // alert(ContainerUniqueIDARR.length);
        // return false;
        if (ContainerUniqueIDARR.length <= 0) {
          this.$refs["assignmentCLose-confirm"].show();
          // alert("Do You Want To Close Billing Assignment");
        } else {
          this.CommonmergeSplitAssignment();
        }
      } else {
        this.CommonmergeSplitAssignment();
      }
      // return false;
      // Changes By Priyanshu Singh End
    },
    async CommonmergeSplitAssignment() {
      
      if (
        this.actionType == "SPLIT" ||
        this.actionType == "CHANGE"
      ) {
       const { canProceed } = await this.checkCBReleaseBeforeFFProceed(2);
        if (!canProceed) {
          return false;
        }
      }
      this.ffExoprtDetail.jobType = this.ShowJOB.split(",");
      this.ffExoprtDetail["previousAssignmentId"] = this.ffExoprtDetail.allModuleId;
      this.ffExoprtDetail["singleSelectContainer"] = this.singleSelectContainer;
      this.ffExoprtDetail["splitContainerType"] = this.splitContainerType;
      this.ffExoprtDetail["splitContainerTypeId"] = this.splitContainerTypeId;
      this.ffExoprtDetail["actionType"] = this.actionType;
      this.ffExoprtDetail["splitContainerTypeCount"] = this.splitContainerTypeCount;
      this.ffExoprtDetail["NewSplitvalidBookingNo"] =this.validBookingNo;

      this.ffExoprtDetail.allModuleId = "";
      // return false;

      console.log("this.ffExoprtDetail => ", this.ffExoprtDetail);
      // return false;
      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/addSplitMergeContainers_NewV3.php`,
        data: JSON.stringify(this.ffExoprtDetail),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.$refs["my-modal-con"].hide();
            this.$refs["my-modal-confirm"].hide();

            this.getData();
            // if (data.status == 400 && data.error) {
            //   this.alert.content =
            //     "REQUEST FAILED ..!! <Booking No Already Linked With Other Assignment";
            //   this.$refs["addPop22"].open();
            // } else {
            //   $("#loader").css("display", "none");
            //   $("#addButtonLoader").css("display", "block");
            //   this.alert.content = "Data Added Successfully";
            //   this.$refs["addPop"].open();
            // }
          }
        })
        .catch((error) => {});
    },

    sendExecutionTeam(type) {
      // console.log("Jio data = >", this.ffExoprtDetail);
      // return false;
      if (type != "cancel") {
        console.log(this.ffExoprtDetail);
        this.ffExoprtDetail.jobType = this.newJobType;
        console.log("Jio data = >", this.ffExoprtDetail);
        // return false;

        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/addMainSalesExec_VP.php`,
          // url: `${URL_BASE}/Enquiry/addMainSalesExec_NewV3_test.php`,
          data: JSON.stringify(this.ffExoprtDetail),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.status == 400 && data.error) {
                $("#loader").css("display", "none");
                $("#addButtonLoader").css("display", "block");
                this.alert.content =
                  "REQUEST FAILED ..!! <Booking No Already Linked With Other Assignment";
                this.$refs["addPop22"].open();
              } else {
                $("#loader").css("display", "none");
                $("#addButtonLoader").css("display", "block");
                this.alert.content = "Data Added Successfully";
                this.$refs["addPop"].open();
              }
            }
          })
          .catch((error) => {});
      } else {
        this.ffExoprtDetail.jobType = [];
        this.newJobType = [];
      }
    },

    validateFFContainer() {
      let validate_new = true;

      if (this.containerModal.containerTypeId == "") {
        $("#containerTypeId").focus();
        this.containerTypeIdError = "Select Container Type";
        validate_new = false;
      }
      if (this.containerModal.noOfContainer == "") {
        $("#noOfContainer").focus();
        this.noOfContainerError = "Enter No of Container";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    checkAllCBBTN() {
      this.checkAllCBVal = this.checkAllCBVal === 0 ? 1 : 0;
    },
    getConsoleBooking() {
      this.ConsoleBookingListMSG = "";
      console.log("checkAllCBVal=>", this.checkAllCBVal);
      let ConsoleBooking = {
        CBooking: "SalesExecutionCB",
        dataType: "CBList",
        transportType: this.ffExoprtDetail.transportType,
        checkAllCBVal: this.checkAllCBVal,
        allModuleId:
          this.$sessionsStorage.get("editSalesExId") != "" ||
          this.$sessionsStorage.get("editSalesExId") != undefined ||
          this.$sessionsStorage.get("editSalesExId") != null
            ? this.$sessionsStorage.get("editSalesExId")
            : "",
        mainEnquiryId:
          this.$sessionsStorage.get("editMainEnqId") != "" ||
          this.$sessionsStorage.get("editMainEnqId") != undefined
            ? this.$sessionsStorage.get("editMainEnqId")
            : "",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_ConsoleBooking/viewAllconsoleBookingList.php`,
        data: JSON.stringify(ConsoleBooking),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            // Added By Priyanshu Singh Start
            if (data.ConsoleBookingList.length > 0) {
              this.ConsoleBookingList = data.ConsoleBookingList;
              console.log(
                "this.ConsoleBookingList SIZE=>",
                this.ConsoleBookingList.length
              );
            } else {
              this.ConsoleBookingList = [];
              this.ConsoleBookingListMSG = data.txt_msg;
            }
          }
        })
        .catch((error) => {});
    },
    getData(No) {
      let array = [];
      this.isLoading = true;
      let vehicle_drive = {
        itemCode: "itemCode",
        exporterClientId: this.ffExoprtDetail.exporterClientId,
        mainEnquiryId:
          this.$sessionsStorage.get("editMainEnqId") != "" ||
          this.$sessionsStorage.get("editMainEnqId") != undefined
            ? this.$sessionsStorage.get("editMainEnqId")
            : "",
        allModuleId:
          this.$sessionsStorage.get("editSalesExId") != "" ||
          this.$sessionsStorage.get("editSalesExId") != undefined
            ? this.$sessionsStorage.get("editSalesExId")
            : "",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/getDataSalesExe.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            if (data.airLineList.length > 0) {
              this.airLineList = data.airLineList;
            }

            if (data.coloaderData.length > 0) {
              this.getColoaderNameList = data.coloaderData;
            }

            if (data.slineDetails.length > 0) {
              this.getShippingLineData = data.slineDetails;
            } else {
              this.getShippingLineData = [];
            }

            if (data.UserData.length > 0) {
              this.ffExoprtDetail.BranchCode = data.UserData[0].BranchCode;
              this.userId = data.UserData[0].userId;
            }

            // if (data.CommodityData.length > 0) {
            //   this.getCommodityData = data.CommodityData;
            // } else {
            //   this.getCommodityData = [];
            // }

            if (data.execDoneData.length > 0) {
              // this.factoryDetail = data.factoryDetail;
              //  this.execDoneData = data.execDoneData;
              // if (
              //   this.execDoneData[0].jobType != "" &&
              //   this.execDoneData[0].jobType != null
              // ) {
              //   let doneArry = this.execDoneData[0].jobType.split(",");
              //   let F = doneArry.includes("FF");
              //   if (F == true) {
              //     this.showSegmentArray[0]["isDisabled"] = true;
              //   }
              //   let C = doneArry.includes("CC");
              //   if (C == true) {
              //     this.showSegmentArray[1]["isDisabled"] = true;
              //   }
              //   let T = doneArry.includes("TPT");
              //   if (T == true) {
              //     this.showSegmentArray[2]["isDisabled"] = true;
              //   }
              // }
            }

            if (data.clientdetail.length > 0) {
              this.getCLientData = data.clientdetail;
            } else {
              this.getCLientData = [];
            }
            if (data.clientdetailImpExp.length > 0) {
              this.getImporterExpo = data.clientdetailImpExp;
            } else {
              this.getImporterExpo = [];
            }
            if (data.factoryDetail.length > 0) {
              this.factoryDetail = data.factoryDetail;
            } else {
              this.factoryDetail = [];
            }

            this.getAlllocationListData = data.LocationDetailsFinal;

            this.getAlllocationHandover = data.LocationDetailsFinal;

            this.getPortDischargeList = data.LocationDetailsSEAPORT;
            this.PortLoadList = data.LocationDetailsSEAPORT;
            this.AirPortLoadList = data.LocationDetailsFinal;
            this.AirIcdPOrtList = data.LocationDetailsFinal;

            this.finalAllPlaceData = data.LocationDetailsFinal;

            if (data.containerMaster.length > 0) {
              this.getContainerTypeData = data.containerMaster;
            } else {
              this.getContainerTypeData = [];
            }
            let multiConType = [];
            let multiConId = [];
            let multiConNo = [];

            if (data.editAssignmentData.length > 0 && No != "No") {
              this.seriesNumber = data.editAssignmentData[0].mainSalesSeries;
              this.allModuleId = data.editAssignmentData[0].allModuleId;
              if (data.editAssignmentData[0].engJobType) {
                this.jobTypeFromEnquiry = data.editAssignmentData[0].engJobType.split(
                  ","
                );
              } else {
                this.jobTypeFromEnquiry = [];
              }
              this.factorySelectedAtEnquiry =
                data.editAssignmentData[0].stuffingLocationId;
              this.ffExoprtDetail.multipleContainerTypeId =
                data.editAssignmentData[0].multipleContainerTypeId;
              this.ShowJOB = data.editAssignmentData[0].jobType;
              if (this.ffExoprtDetail["portType"] == "Icd") {
                this.IcdPOrtList = data.LocationDetailsSEAPORT;
              } else {
                this.IcdPOrtList = data.LocationDetailsSEAPORT;
              }

              if(data.editAssignmentData[0].transportType=='Domestic'){
                this.transportTypeName= [
                  {
                    transportTypeVal: "Export",
                    transportTypeText: "Export",
                  },
                  {
                    transportTypeVal: "Import",
                    transportTypeText: "Import",
                  },
                  {
                    transportTypeVal: "Domestic",
                    transportTypeText: "Domestic",
                  },
                ];
              }

              Object.keys(data.editAssignmentData[0]).map((x) => {
                if (x == "jobType") {
                  array = data.editAssignmentData[0][x].split(",");
                  this.newJobType = data.editAssignmentData[0][x].split(",");
                } else if (x == "multipleContainerType") {
                // } else if (x == "multipleContainerType" && data.editAssignmentData[0].transportType!='Domestic') {
                  if (data.editAssignmentData[0][x] != "") {
                    multiConType = data.editAssignmentData[0][x].split(",") || [];
                  } else {
                    multiConType = [];
                  }
                } else if (x == "multipleContainerTypeId") {
                // } else if (x == "multipleContainerTypeId" && data.editAssignmentData[0].transportType!='Domestic') {
                  if (data.editAssignmentData[0][x] != "") {
                    multiConId = data.editAssignmentData[0][x].split(",") || [];
                  } else {
                    multiConId = [];
                  }
                } else if (x == "multiConNo") {
                // } else if (x == "multiConNo" && data.editAssignmentData[0].transportType!='Domestic') {
                  if (data.editAssignmentData[0][x] != "") {
                    multiConNo = data.editAssignmentData[0][x].split(",") || [];
                  } else {
                    multiConNo = [];
                  }
                } else {
                  this.ffExoprtDetail[x] = data.editAssignmentData[0][x] || "";
                }
              });
              this.multiContainer = [];
              if (multiConId.length > 0) {
                multiConId.map((p, index) => {
                  let obj = {
                    containerTypeID: p,
                    containerType: multiConType[index],
                    freghtContainersNo: multiConNo[index],
                  };

                  this.multiContainer.push(obj);
                });
              }

              this.ffExoprtDetail["jobType"] = [];

              if (
                this.$sessionsStorage.get("editSalesExId") == "" ||
                this.$sessionsStorage.get("editSalesExId") == null
              ) {
                if (
                  this.ffExoprtDetail.ccStatus == "0" ||
                  this.ffExoprtDetail.ccExpired == "1"
                ) {
                  let i = array.indexOf("CC");
                  if (i >= 0) {
                    array.splice(i, 1);
                  }
                }

                // Added By Priyanshu Singh Start
                // if (data.ConsoleBookingList.length > 0) {
                //   this.ConsoleBookingList = data.ConsoleBookingList;
                // } else {
                //   this.ConsoleBookingList = [];
                // }
                if (
                  this.newJobType.indexOf("FF") >= 0 &&
                  data.editAssignmentData[0].transportType == "Export" &&
                  data.editAssignmentData[0].shipmentType == 1 &&
                  data.editAssignmentData[0].shipmentType == "fcl"
                ) {
                  this.ffExoprtDetail.validmultiBookingNo = JSON.parse(
                    data.editAssignmentData[0].validmultiBookingNo
                  );
                  this.items = JSON.parse(data.editAssignmentData[0].validmultiBookingNo);
                  this.ffExoprtDetail.validBookingNo = "";
                  // this.ffExoprtDetail.validBookingNo = data.editAssignmentData[0].validBookingNo;
                } else {
                  this.ffExoprtDetail.validBookingNo =
                    data.editAssignmentData[0].validBookingNo;
                  this.ffExoprtDetail.validmultiBookingNo = [];
                }
                // Added By Priyanshu Singh End

                if (
                  this.newJobType.indexOf("FF") >= 0 &&
                  data.editAssignmentData[0].shippingId != ""
                ) {
                  this.ffExoprtDetail.shippingId = "";
                  this.ffExoprtDetail.shippingId =
                    data.editAssignmentData[0].approvedSLine;
                }

                if (
                  this.ffExoprtDetail.tptStatus == "0" ||
                  this.ffExoprtDetail.tptExpired == "1"
                ) {
                  let i = array.indexOf("TPT");
                  if (i >= 0) {
                    array.splice(i, 1);
                  }
                }
                if (
                  this.ffExoprtDetail.ffStatus == "0" ||
                  this.ffExoprtDetail.ffExpired == "1"
                ) {
                  let i = array.indexOf("FF");
                  if (i >= 0) {
                    array.splice(i, 1);
                  }
                }
              } else {
                this.ffExoprtDetail.shippingId = data.editAssignmentData[0].shippingId;
                console.log(this.ffExoprtDetail.shippingId, "piuo");
              }
              this.ffExoprtDetail.airlineId = data.editAssignmentData[0].approvedAirLine;
              this.ffExoprtDetail.coLoaderId = data.editAssignmentData[0].coLoaderId;
              this.ffExoprtDetail.mainEnquirySeries =
                data.editAssignmentData[0].mainEnquirySeries;

              this.showSegmentArray.map((x, index) => {
                let i = array.indexOf(x.value);

                if (i < 0) {
                  this.ffExoprtDetail.jobType[index] = false;
                  this.showSegmentArray[index]["isDisabled"] = true;
                }

                // if (array.length == 1) {
                //   // this.showSegmentArray[index]["isDisabled"] = true;
                // }
              });

              //  if( data.editAssignmentData[0].mainEnquirySeries){
              //     data.editAssignmentData[0].clientType =
              //  }
            } else {
              this.IcdPOrtList = data.LocationDetailsSEAPORT;
            }
            if (
              No != "No" &&
              this.ffExoprtDetail.clientType == "3" &&
              this.ffExoprtDetail.shipmentType == "1" &&
              this.ffExoprtDetail.transportType == "Export"
            ) {
              //this.ffExoprtDetail.exporterClientId = "";
            }

            if (this.$sessionsStorage.get("isFFValid") == "false") {
              this.showSegmentArray[0]["isDisabled"] = true;
            }
            if (this.$sessionsStorage.get("isCCValid") == "false") {
              this.showSegmentArray[1]["isDisabled"] = true;
            }
            // if (this.$sessionsStorage.get("isCCValid") == "false") {
            //   this.showSegmentArray[2]["isDisabled"] = true;
            // }
            if (this.$sessionsStorage.get("isTPTValid") == "false") {
              this.showSegmentArray[2]["isDisabled"] = true;
            }
            console.log(" this.showSegmentArray=>", this.showSegmentArray);
            if (data.factoryDetail.length > 0) {
              let arryF = data.factoryDetail.filter((x) => {
                return x.pickupId == this.factorySelectedAtEnquiry;
              });
              if (arryF.length > 0) {
                console.log("Factory Exists");
                this.disableFactory = true;
              } else {
                this.ffExoprtDetail.stuffingLocationId = "";
                this.disableFactory = false;
              }
              // this.factoryDetail = data.factoryDetail;
              this.tempfactoryDetail = data.factoryDetail;
              this.getAlllocationListDataFactory = data.factoryDetail;
            }
            if (
              !this.ffExoprtDetail.finalPlaceLocationId ||
              this.ffExoprtDetail.finalPlaceLocationId == "0"
            ) {
              this.finalAllPlaceData = [];
            }
            if (
              !this.ffExoprtDetail.LPlocationId ||
              this.ffExoprtDetail.LPlocationId == "0"
            ) {
              this.PortLoadList = [];
            }
            if (
              !this.ffExoprtDetail.PODLocationId ||
              this.ffExoprtDetail.PODLocationId == "0"
            ) {
              this.PortDischargeList = [];
            }
            if (No != "No") {
              this.newJobType = [];
            }
            if (data.ContainerVolumesArr.length > 0) {
              this.ContainerVolumesArr = data.ContainerVolumesArr;
            }
            
            this.getConsoleBooking();
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },

    addNew() {
      this.$router.push({
        path: "/client/addClient",
      });
    },
    //  showExpInput() {
    //   if (this.ffExoprtDetail.exporterClientId != "") {
    //     let dummyExporter = this.getImporterExpo.filter(x => {
    //       return x.clientId == this.ffExoprtDetail.exporterClientId;
    //     });
    //     if (dummyExporter.length > 0) {
    //       if (dummyExporter[0].clientName == "Others") {
    //         this.openExpoInput = true;
    //       } else {
    //         this.openExpoInput = false;
    //       }
    //     }
    //   }
    //   if (this.ffExoprtDetail.importerClientId != "") {
    //     let dummyImporter = this.getImporterExpo.filter(x => {
    //       return x.clientId == this.ffExoprtDetail.importerClientId;
    //     });
    //     if (dummyImporter.length > 0) {
    //       if (dummyImporter[0].clientName == "Others") {
    //         this.openImpoInput = true;
    //       } else {
    //         this.openImpoInput = false;
    //       }
    //     }
    //   }
    // },

    previousFFView() {
      window.history.go(-1);
      // if (
      //   this.$sessionsStorage.get("editSalesExId") != "" &&
      //   this.$sessionsStorage.get("editSalesExId") != null &&
      //   this.$sessionsStorage.get("editSalesExId") != undefined
      // ) {
      //   this.$router.push({
      //     path: "/viewAllModuleDetails/viewAllModuleDetails"
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/viewMainEnquiryDetails/viewMainEnquiryDetails"
      //   });
      // }
    },

    getServicesData() {
      this.showSegmentArray = [
        {
          value: "FF",
          show: "FREIGHT FORWARDING (FF)",
          flex: "30",
          isDisabled: false,
        },
        {
          value: "CC",
          show: "CUSTOM CLEARANCE (CC)",
          flex: "30",
          isDisabled: false,
        },
        {
          value: "TPT",
          show: "TRANSPORTATION (TPT)",
          flex: "30",
          isDisabled: false,
        },

        // {
        //   value: "All",
        //   show: "All",
        //   flex: "15"
        // }
      ];
    },
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// salesExecutionAll.vue?6941a7ce